/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StudioRouteImport } from './routes/studio'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PasswordResetRouteImport } from './routes/password-reset'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as EmailConfirmRouteImport } from './routes/email-confirm'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as ProtectedRouteRouteImport } from './routes/protected/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ContractTokenRouteImport } from './routes/contract.$token'
import { Route as ProtectedLayoutRouteRouteImport } from './routes/protected/_layout/route'
import { Route as ProtectedLayoutIndexRouteImport } from './routes/protected/_layout/index'
import { Route as ProtectedLayoutToInvoiceRouteImport } from './routes/protected/_layout/to-invoice'
import { Route as ProtectedLayoutHelpRouteImport } from './routes/protected/_layout/help'
import { Route as ProtectedLayoutDashboardRouteImport } from './routes/protected/_layout/dashboard'
import { Route as ProtectedLayoutAiChatRouteImport } from './routes/protected/_layout/ai-chat'
import { Route as DWrTokenRouteImport } from './routes/d.wr.$token'
import { Route as ProtectedLayoutHelpIndexRouteImport } from './routes/protected/_layout/help.index'
import { Route as ProtectedLayoutWorkReportsLayoutRouteImport } from './routes/protected/_layout/work-reports/_layout'
import { Route as ProtectedLayoutWarehouseLayoutRouteImport } from './routes/protected/_layout/warehouse/_layout'
import { Route as ProtectedLayoutSupportLayoutRouteImport } from './routes/protected/_layout/support/_layout'
import { Route as ProtectedLayoutSettingsLayoutRouteImport } from './routes/protected/_layout/settings/_layout'
import { Route as ProtectedLayoutServiceContractsLayoutRouteImport } from './routes/protected/_layout/service-contracts/_layout'
import { Route as ProtectedLayoutRegistryLayoutRouteImport } from './routes/protected/_layout/registry/_layout'
import { Route as ProtectedLayoutProductsLayoutRouteImport } from './routes/protected/_layout/products/_layout'
import { Route as ProtectedLayoutPriceListsLayoutRouteImport } from './routes/protected/_layout/price-lists/_layout'
import { Route as ProtectedLayoutPaymentsLayoutRouteImport } from './routes/protected/_layout/payments/_layout'
import { Route as ProtectedLayoutOrdersLayoutRouteImport } from './routes/protected/_layout/orders/_layout'
import { Route as ProtectedLayoutMachinesLayoutRouteImport } from './routes/protected/_layout/machines/_layout'
import { Route as ProtectedLayoutMachineChecksLayoutRouteImport } from './routes/protected/_layout/machine-checks/_layout'
import { Route as ProtectedLayoutInvoicesLayoutRouteImport } from './routes/protected/_layout/invoices/_layout'
import { Route as ProtectedLayoutInventoryLayoutRouteImport } from './routes/protected/_layout/inventory/_layout'
import { Route as ProtectedLayoutHotelLayoutRouteImport } from './routes/protected/_layout/hotel/_layout'
import { Route as ProtectedLayoutHelpFaqRouteImport } from './routes/protected/_layout/help.faq'
import { Route as ProtectedLayoutHelpCategoryRouteImport } from './routes/protected/_layout/help.$category'
import { Route as ProtectedLayoutForecastLayoutRouteImport } from './routes/protected/_layout/forecast/_layout'
import { Route as ProtectedLayoutDocumentsLayoutRouteImport } from './routes/protected/_layout/documents/_layout'
import { Route as ProtectedLayoutDocumentPaymentSchedulesLayoutRouteImport } from './routes/protected/_layout/document-payment-schedules/_layout'
import { Route as ProtectedLayoutDistinteRibaLayoutRouteImport } from './routes/protected/_layout/distinte-riba/_layout'
import { Route as ProtectedLayoutDeliveryNotesLayoutRouteImport } from './routes/protected/_layout/delivery-notes/_layout'
import { Route as ProtectedLayoutCommesseLayoutRouteImport } from './routes/protected/_layout/commesse/_layout'
import { Route as ProtectedLayoutAdministrationLayoutRouteImport } from './routes/protected/_layout/administration/_layout'
import { Route as ProtectedLayoutAccountsLayoutRouteImport } from './routes/protected/_layout/accounts/_layout'
import { Route as ProtectedLayoutWorkReportsLayoutIndexRouteImport } from './routes/protected/_layout/work-reports/_layout.index'
import { Route as ProtectedLayoutWarehouseLayoutIndexRouteImport } from './routes/protected/_layout/warehouse/_layout.index'
import { Route as ProtectedLayoutSupportLayoutIndexRouteImport } from './routes/protected/_layout/support/_layout.index'
import { Route as ProtectedLayoutSettingsLayoutIndexRouteImport } from './routes/protected/_layout/settings/_layout.index'
import { Route as ProtectedLayoutServiceContractsLayoutIndexRouteImport } from './routes/protected/_layout/service-contracts/_layout.index'
import { Route as ProtectedLayoutRegistryLayoutIndexRouteImport } from './routes/protected/_layout/registry/_layout.index'
import { Route as ProtectedLayoutProductsLayoutIndexRouteImport } from './routes/protected/_layout/products/_layout.index'
import { Route as ProtectedLayoutPriceListsLayoutIndexRouteImport } from './routes/protected/_layout/price-lists/_layout.index'
import { Route as ProtectedLayoutPaymentsLayoutIndexRouteImport } from './routes/protected/_layout/payments/_layout.index'
import { Route as ProtectedLayoutOrdersLayoutIndexRouteImport } from './routes/protected/_layout/orders/_layout.index'
import { Route as ProtectedLayoutMachinesLayoutIndexRouteImport } from './routes/protected/_layout/machines/_layout.index'
import { Route as ProtectedLayoutMachineChecksLayoutIndexRouteImport } from './routes/protected/_layout/machine-checks/_layout.index'
import { Route as ProtectedLayoutInvoicesLayoutIndexRouteImport } from './routes/protected/_layout/invoices/_layout.index'
import { Route as ProtectedLayoutInventoryLayoutIndexRouteImport } from './routes/protected/_layout/inventory/_layout.index'
import { Route as ProtectedLayoutHotelLayoutIndexRouteImport } from './routes/protected/_layout/hotel/_layout.index'
import { Route as ProtectedLayoutHelpCategoryIndexRouteImport } from './routes/protected/_layout/help.$category.index'
import { Route as ProtectedLayoutForecastLayoutIndexRouteImport } from './routes/protected/_layout/forecast/_layout.index'
import { Route as ProtectedLayoutDocumentsLayoutIndexRouteImport } from './routes/protected/_layout/documents/_layout.index'
import { Route as ProtectedLayoutDocumentPaymentSchedulesLayoutIndexRouteImport } from './routes/protected/_layout/document-payment-schedules/_layout.index'
import { Route as ProtectedLayoutDistinteRibaLayoutIndexRouteImport } from './routes/protected/_layout/distinte-riba/_layout.index'
import { Route as ProtectedLayoutDeliveryNotesLayoutIndexRouteImport } from './routes/protected/_layout/delivery-notes/_layout.index'
import { Route as ProtectedLayoutCommesseLayoutIndexRouteImport } from './routes/protected/_layout/commesse/_layout.index'
import { Route as ProtectedLayoutAdministrationLayoutIndexRouteImport } from './routes/protected/_layout/administration/_layout.index'
import { Route as ProtectedLayoutAccountsLayoutIndexRouteImport } from './routes/protected/_layout/accounts/_layout.index'
import { Route as ProtectedLayoutWorkReportsLayoutNewRouteImport } from './routes/protected/_layout/work-reports/_layout.new'
import { Route as ProtectedLayoutWorkReportsLayoutIdRouteImport } from './routes/protected/_layout/work-reports/_layout.$id'
import { Route as ProtectedLayoutSupportLayoutNewRouteImport } from './routes/protected/_layout/support/_layout.new'
import { Route as ProtectedLayoutSupportLayoutIdRouteImport } from './routes/protected/_layout/support/_layout.$id'
import { Route as ProtectedLayoutServiceContractsLayoutNewRouteImport } from './routes/protected/_layout/service-contracts/_layout.new'
import { Route as ProtectedLayoutServiceContractsLayoutIdRouteImport } from './routes/protected/_layout/service-contracts/_layout.$id'
import { Route as ProtectedLayoutProductsLayoutNewRouteImport } from './routes/protected/_layout/products/_layout.new'
import { Route as ProtectedLayoutProductsLayoutIdRouteImport } from './routes/protected/_layout/products/_layout.$id'
import { Route as ProtectedLayoutPriceListsLayoutNewRouteImport } from './routes/protected/_layout/price-lists/_layout.new'
import { Route as ProtectedLayoutPriceListsLayoutIdRouteImport } from './routes/protected/_layout/price-lists/_layout.$id'
import { Route as ProtectedLayoutOrdersLayoutNewRouteImport } from './routes/protected/_layout/orders/_layout.new'
import { Route as ProtectedLayoutOrdersLayoutIdRouteImport } from './routes/protected/_layout/orders/_layout.$id'
import { Route as ProtectedLayoutMachinesLayoutNewRouteImport } from './routes/protected/_layout/machines/_layout.new'
import { Route as ProtectedLayoutMachinesLayoutIdRouteImport } from './routes/protected/_layout/machines/_layout.$id'
import { Route as ProtectedLayoutInvoicesLayoutNewRouteImport } from './routes/protected/_layout/invoices/_layout.new'
import { Route as ProtectedLayoutInvoicesLayoutIdRouteImport } from './routes/protected/_layout/invoices/_layout.$id'
import { Route as ProtectedLayoutInventoryLayoutNewRouteImport } from './routes/protected/_layout/inventory/_layout.new'
import { Route as ProtectedLayoutInventoryLayoutIdRouteImport } from './routes/protected/_layout/inventory/_layout.$id'
import { Route as ProtectedLayoutHotelLayoutNewRouteImport } from './routes/protected/_layout/hotel/_layout.new'
import { Route as ProtectedLayoutHotelLayoutIdRouteImport } from './routes/protected/_layout/hotel/_layout.$id'
import { Route as ProtectedLayoutHelpCategoryArticleRouteImport } from './routes/protected/_layout/help.$category.$article'
import { Route as ProtectedLayoutDocumentsLayoutNewRouteImport } from './routes/protected/_layout/documents/_layout.new'
import { Route as ProtectedLayoutDocumentsLayoutIdRouteImport } from './routes/protected/_layout/documents/_layout.$id'
import { Route as ProtectedLayoutDocumentPaymentSchedulesLayoutNewRouteImport } from './routes/protected/_layout/document-payment-schedules/_layout.new'
import { Route as ProtectedLayoutDocumentPaymentSchedulesLayoutIdRouteImport } from './routes/protected/_layout/document-payment-schedules/_layout.$id'
import { Route as ProtectedLayoutDeliveryNotesLayoutNewRouteImport } from './routes/protected/_layout/delivery-notes/_layout.new'
import { Route as ProtectedLayoutDeliveryNotesLayoutIdRouteImport } from './routes/protected/_layout/delivery-notes/_layout.$id'
import { Route as ProtectedLayoutCommesseLayoutNewRouteImport } from './routes/protected/_layout/commesse/_layout.new'
import { Route as ProtectedLayoutCommesseLayoutIdRouteImport } from './routes/protected/_layout/commesse/_layout.$id'
import { Route as ProtectedLayoutAdministrationLayoutNewRouteImport } from './routes/protected/_layout/administration/_layout.new'
import { Route as ProtectedLayoutAdministrationLayoutIdRouteImport } from './routes/protected/_layout/administration/_layout.$id'
import { Route as ProtectedLayoutAccountsLayoutNewRouteImport } from './routes/protected/_layout/accounts/_layout.new'
import { Route as ProtectedLayoutAccountsLayoutIdRouteImport } from './routes/protected/_layout/accounts/_layout.$id'
import { Route as ProtectedLayoutSettingsLayoutUsersNewRouteImport } from './routes/protected/_layout/settings/_layout.users.new'
import { Route as ProtectedLayoutSettingsLayoutUsersIdRouteImport } from './routes/protected/_layout/settings/_layout.users.$id'
import { Route as ProtectedLayoutSettingsLayoutCategoriesNewRouteImport } from './routes/protected/_layout/settings/_layout.categories.new'
import { Route as ProtectedLayoutSettingsLayoutCategoriesIdRouteImport } from './routes/protected/_layout/settings/_layout.categories.$id'
import { Route as ProtectedLayoutRegistryLayoutProductsNewServiceRouteImport } from './routes/protected/_layout/registry/_layout.products.new-service'
import { Route as ProtectedLayoutRegistryLayoutProductsNewRouteImport } from './routes/protected/_layout/registry/_layout.products.new'
import { Route as ProtectedLayoutRegistryLayoutProductsIdRouteImport } from './routes/protected/_layout/registry/_layout.products.$id'
import { Route as ProtectedLayoutRegistryLayoutEmployeesNewRouteImport } from './routes/protected/_layout/registry/_layout.employees.new'
import { Route as ProtectedLayoutRegistryLayoutEmployeesIdRouteImport } from './routes/protected/_layout/registry/_layout.employees.$id'
import { Route as ProtectedLayoutRegistryLayoutCounterpartsNewRouteImport } from './routes/protected/_layout/registry/_layout.counterparts.new'
import { Route as ProtectedLayoutRegistryLayoutCounterpartsIdRouteImport } from './routes/protected/_layout/registry/_layout.counterparts.$id'
import { Route as ProtectedLayoutPaymentsLayoutDocumentsIdRouteImport } from './routes/protected/_layout/payments/_layout.documents.$id'
import { Route as ProtectedLayoutMachineChecksLayoutChecksIdRouteImport } from './routes/protected/_layout/machine-checks/_layout.checks.$id'
import { Route as ProtectedLayoutForecastLayoutRecurrencesNewRouteImport } from './routes/protected/_layout/forecast/_layout.recurrences.new'
import { Route as ProtectedLayoutForecastLayoutRecurrencesIdRouteImport } from './routes/protected/_layout/forecast/_layout.recurrences.$id'
import { Route as ProtectedLayoutForecastLayoutPlanningNewRouteImport } from './routes/protected/_layout/forecast/_layout.planning.new'
import { Route as ProtectedLayoutForecastLayoutPlanningIdRouteImport } from './routes/protected/_layout/forecast/_layout.planning.$id'
import { Route as ProtectedLayoutForecastLayoutForecastNewRouteImport } from './routes/protected/_layout/forecast/_layout.forecast.new'
import { Route as ProtectedLayoutForecastLayoutForecastIdRouteImport } from './routes/protected/_layout/forecast/_layout.forecast.$id'
import { Route as ProtectedLayoutForecastLayoutDocumentIdRouteImport } from './routes/protected/_layout/forecast/_layout.document.$id'
import { Route as ProtectedLayoutForecastLayoutCashMovementIdRouteImport } from './routes/protected/_layout/forecast/_layout.cash-movement.$id'
import { Route as ProtectedLayoutDocumentsLayoutDebtsNewRouteImport } from './routes/protected/_layout/documents/_layout.debts.new'
import { Route as ProtectedLayoutDocumentsLayoutDebtsIdRouteImport } from './routes/protected/_layout/documents/_layout.debts.$id'
import { Route as ProtectedLayoutAccountsLayoutMovementsNewRouteImport } from './routes/protected/_layout/accounts/_layout.movements.new'
import { Route as ProtectedLayoutAccountsLayoutMovementsIdRouteImport } from './routes/protected/_layout/accounts/_layout.movements.$id'
import { Route as ProtectedLayoutSettingsLayoutCategoriesIdKeywordsRouteImport } from './routes/protected/_layout/settings/_layout.categories.$id.keywords'

const ProtectedLayoutWorkReportsRouteImport = createFileRoute(
  '/protected/_layout/work-reports',
)()
const ProtectedLayoutWarehouseRouteImport = createFileRoute(
  '/protected/_layout/warehouse',
)()
const ProtectedLayoutSupportRouteImport = createFileRoute(
  '/protected/_layout/support',
)()
const ProtectedLayoutSettingsRouteImport = createFileRoute(
  '/protected/_layout/settings',
)()
const ProtectedLayoutServiceContractsRouteImport = createFileRoute(
  '/protected/_layout/service-contracts',
)()
const ProtectedLayoutRegistryRouteImport = createFileRoute(
  '/protected/_layout/registry',
)()
const ProtectedLayoutProductsRouteImport = createFileRoute(
  '/protected/_layout/products',
)()
const ProtectedLayoutPriceListsRouteImport = createFileRoute(
  '/protected/_layout/price-lists',
)()
const ProtectedLayoutPaymentsRouteImport = createFileRoute(
  '/protected/_layout/payments',
)()
const ProtectedLayoutOrdersRouteImport = createFileRoute(
  '/protected/_layout/orders',
)()
const ProtectedLayoutMachinesRouteImport = createFileRoute(
  '/protected/_layout/machines',
)()
const ProtectedLayoutMachineChecksRouteImport = createFileRoute(
  '/protected/_layout/machine-checks',
)()
const ProtectedLayoutInvoicesRouteImport = createFileRoute(
  '/protected/_layout/invoices',
)()
const ProtectedLayoutInventoryRouteImport = createFileRoute(
  '/protected/_layout/inventory',
)()
const ProtectedLayoutHotelRouteImport = createFileRoute(
  '/protected/_layout/hotel',
)()
const ProtectedLayoutForecastRouteImport = createFileRoute(
  '/protected/_layout/forecast',
)()
const ProtectedLayoutDocumentsRouteImport = createFileRoute(
  '/protected/_layout/documents',
)()
const ProtectedLayoutDocumentPaymentSchedulesRouteImport = createFileRoute(
  '/protected/_layout/document-payment-schedules',
)()
const ProtectedLayoutDistinteRibaRouteImport = createFileRoute(
  '/protected/_layout/distinte-riba',
)()
const ProtectedLayoutDeliveryNotesRouteImport = createFileRoute(
  '/protected/_layout/delivery-notes',
)()
const ProtectedLayoutCommesseRouteImport = createFileRoute(
  '/protected/_layout/commesse',
)()
const ProtectedLayoutAdministrationRouteImport = createFileRoute(
  '/protected/_layout/administration',
)()
const ProtectedLayoutAccountsRouteImport = createFileRoute(
  '/protected/_layout/accounts',
)()

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioRoute = StudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetRoute = PasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpersonateRoute = ImpersonateRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailConfirmRoute = EmailConfirmRouteImport.update({
  id: '/email-confirm',
  path: '/email-confirm',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRouteRoute = ProtectedRouteRouteImport.update({
  id: '/protected',
  path: '/protected',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractTokenRoute = ContractTokenRouteImport.update({
  id: '/contract/$token',
  path: '/contract/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedLayoutRouteRoute = ProtectedLayoutRouteRouteImport.update({
  id: '/_layout',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedLayoutWorkReportsRoute =
  ProtectedLayoutWorkReportsRouteImport.update({
    id: '/work-reports',
    path: '/work-reports',
    getParentRoute: () => ProtectedLayoutRouteRoute,
  } as any)
const ProtectedLayoutWarehouseRoute =
  ProtectedLayoutWarehouseRouteImport.update({
    id: '/warehouse',
    path: '/warehouse',
    getParentRoute: () => ProtectedLayoutRouteRoute,
  } as any)
const ProtectedLayoutSupportRoute = ProtectedLayoutSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => ProtectedLayoutRouteRoute,
} as any)
const ProtectedLayoutSettingsRoute = ProtectedLayoutSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ProtectedLayoutRouteRoute,
} as any)
const ProtectedLayoutServiceContractsRoute =
  ProtectedLayoutServiceContractsRouteImport.update({
    id: '/service-contracts',
    path: '/service-contracts',
    getParentRoute: () => ProtectedLayoutRouteRoute,
  } as any)
const ProtectedLayoutRegistryRoute = ProtectedLayoutRegistryRouteImport.update({
  id: '/registry',
  path: '/registry',
  getParentRoute: () => ProtectedLayoutRouteRoute,
} as any)
const ProtectedLayoutProductsRoute = ProtectedLayoutProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => ProtectedLayoutRouteRoute,
} as any)
const ProtectedLayoutPriceListsRoute =
  ProtectedLayoutPriceListsRouteImport.update({
    id: '/price-lists',
    path: '/price-lists',
    getParentRoute: () => ProtectedLayoutRouteRoute,
  } as any)
const ProtectedLayoutPaymentsRoute = ProtectedLayoutPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => ProtectedLayoutRouteRoute,
} as any)
const ProtectedLayoutOrdersRoute = ProtectedLayoutOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => ProtectedLayoutRouteRoute,
} as any)
const ProtectedLayoutMachinesRoute = ProtectedLayoutMachinesRouteImport.update({
  id: '/machines',
  path: '/machines',
  getParentRoute: () => ProtectedLayoutRouteRoute,
} as any)
const ProtectedLayoutMachineChecksRoute =
  ProtectedLayoutMachineChecksRouteImport.update({
    id: '/machine-checks',
    path: '/machine-checks',
    getParentRoute: () => ProtectedLayoutRouteRoute,
  } as any)
const ProtectedLayoutInvoicesRoute = ProtectedLayoutInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => ProtectedLayoutRouteRoute,
} as any)
const ProtectedLayoutInventoryRoute =
  ProtectedLayoutInventoryRouteImport.update({
    id: '/inventory',
    path: '/inventory',
    getParentRoute: () => ProtectedLayoutRouteRoute,
  } as any)
const ProtectedLayoutHotelRoute = ProtectedLayoutHotelRouteImport.update({
  id: '/hotel',
  path: '/hotel',
  getParentRoute: () => ProtectedLayoutRouteRoute,
} as any)
const ProtectedLayoutForecastRoute = ProtectedLayoutForecastRouteImport.update({
  id: '/forecast',
  path: '/forecast',
  getParentRoute: () => ProtectedLayoutRouteRoute,
} as any)
const ProtectedLayoutDocumentsRoute =
  ProtectedLayoutDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => ProtectedLayoutRouteRoute,
  } as any)
const ProtectedLayoutDocumentPaymentSchedulesRoute =
  ProtectedLayoutDocumentPaymentSchedulesRouteImport.update({
    id: '/document-payment-schedules',
    path: '/document-payment-schedules',
    getParentRoute: () => ProtectedLayoutRouteRoute,
  } as any)
const ProtectedLayoutDistinteRibaRoute =
  ProtectedLayoutDistinteRibaRouteImport.update({
    id: '/distinte-riba',
    path: '/distinte-riba',
    getParentRoute: () => ProtectedLayoutRouteRoute,
  } as any)
const ProtectedLayoutDeliveryNotesRoute =
  ProtectedLayoutDeliveryNotesRouteImport.update({
    id: '/delivery-notes',
    path: '/delivery-notes',
    getParentRoute: () => ProtectedLayoutRouteRoute,
  } as any)
const ProtectedLayoutCommesseRoute = ProtectedLayoutCommesseRouteImport.update({
  id: '/commesse',
  path: '/commesse',
  getParentRoute: () => ProtectedLayoutRouteRoute,
} as any)
const ProtectedLayoutAdministrationRoute =
  ProtectedLayoutAdministrationRouteImport.update({
    id: '/administration',
    path: '/administration',
    getParentRoute: () => ProtectedLayoutRouteRoute,
  } as any)
const ProtectedLayoutAccountsRoute = ProtectedLayoutAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => ProtectedLayoutRouteRoute,
} as any)
const ProtectedLayoutIndexRoute = ProtectedLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedLayoutRouteRoute,
} as any)
const ProtectedLayoutToInvoiceRoute =
  ProtectedLayoutToInvoiceRouteImport.update({
    id: '/to-invoice',
    path: '/to-invoice',
    getParentRoute: () => ProtectedLayoutRouteRoute,
  } as any)
const ProtectedLayoutHelpRoute = ProtectedLayoutHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => ProtectedLayoutRouteRoute,
} as any)
const ProtectedLayoutDashboardRoute =
  ProtectedLayoutDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => ProtectedLayoutRouteRoute,
  } as any)
const ProtectedLayoutAiChatRoute = ProtectedLayoutAiChatRouteImport.update({
  id: '/ai-chat',
  path: '/ai-chat',
  getParentRoute: () => ProtectedLayoutRouteRoute,
} as any)
const DWrTokenRoute = DWrTokenRouteImport.update({
  id: '/d/wr/$token',
  path: '/d/wr/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedLayoutHelpIndexRoute =
  ProtectedLayoutHelpIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutHelpRoute,
  } as any)
const ProtectedLayoutWorkReportsLayoutRoute =
  ProtectedLayoutWorkReportsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutWorkReportsRoute,
  } as any)
const ProtectedLayoutWarehouseLayoutRoute =
  ProtectedLayoutWarehouseLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutWarehouseRoute,
  } as any)
const ProtectedLayoutSupportLayoutRoute =
  ProtectedLayoutSupportLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutSupportRoute,
  } as any)
const ProtectedLayoutSettingsLayoutRoute =
  ProtectedLayoutSettingsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutSettingsRoute,
  } as any)
const ProtectedLayoutServiceContractsLayoutRoute =
  ProtectedLayoutServiceContractsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutServiceContractsRoute,
  } as any)
const ProtectedLayoutRegistryLayoutRoute =
  ProtectedLayoutRegistryLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutRegistryRoute,
  } as any)
const ProtectedLayoutProductsLayoutRoute =
  ProtectedLayoutProductsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutProductsRoute,
  } as any)
const ProtectedLayoutPriceListsLayoutRoute =
  ProtectedLayoutPriceListsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutPriceListsRoute,
  } as any)
const ProtectedLayoutPaymentsLayoutRoute =
  ProtectedLayoutPaymentsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutPaymentsRoute,
  } as any)
const ProtectedLayoutOrdersLayoutRoute =
  ProtectedLayoutOrdersLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutOrdersRoute,
  } as any)
const ProtectedLayoutMachinesLayoutRoute =
  ProtectedLayoutMachinesLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutMachinesRoute,
  } as any)
const ProtectedLayoutMachineChecksLayoutRoute =
  ProtectedLayoutMachineChecksLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutMachineChecksRoute,
  } as any)
const ProtectedLayoutInvoicesLayoutRoute =
  ProtectedLayoutInvoicesLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutInvoicesRoute,
  } as any)
const ProtectedLayoutInventoryLayoutRoute =
  ProtectedLayoutInventoryLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutInventoryRoute,
  } as any)
const ProtectedLayoutHotelLayoutRoute =
  ProtectedLayoutHotelLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutHotelRoute,
  } as any)
const ProtectedLayoutHelpFaqRoute = ProtectedLayoutHelpFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => ProtectedLayoutHelpRoute,
} as any)
const ProtectedLayoutHelpCategoryRoute =
  ProtectedLayoutHelpCategoryRouteImport.update({
    id: '/$category',
    path: '/$category',
    getParentRoute: () => ProtectedLayoutHelpRoute,
  } as any)
const ProtectedLayoutForecastLayoutRoute =
  ProtectedLayoutForecastLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutForecastRoute,
  } as any)
const ProtectedLayoutDocumentsLayoutRoute =
  ProtectedLayoutDocumentsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutDocumentsRoute,
  } as any)
const ProtectedLayoutDocumentPaymentSchedulesLayoutRoute =
  ProtectedLayoutDocumentPaymentSchedulesLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutDocumentPaymentSchedulesRoute,
  } as any)
const ProtectedLayoutDistinteRibaLayoutRoute =
  ProtectedLayoutDistinteRibaLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutDistinteRibaRoute,
  } as any)
const ProtectedLayoutDeliveryNotesLayoutRoute =
  ProtectedLayoutDeliveryNotesLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutDeliveryNotesRoute,
  } as any)
const ProtectedLayoutCommesseLayoutRoute =
  ProtectedLayoutCommesseLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutCommesseRoute,
  } as any)
const ProtectedLayoutAdministrationLayoutRoute =
  ProtectedLayoutAdministrationLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutAdministrationRoute,
  } as any)
const ProtectedLayoutAccountsLayoutRoute =
  ProtectedLayoutAccountsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ProtectedLayoutAccountsRoute,
  } as any)
const ProtectedLayoutWorkReportsLayoutIndexRoute =
  ProtectedLayoutWorkReportsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutWorkReportsLayoutRoute,
  } as any)
const ProtectedLayoutWarehouseLayoutIndexRoute =
  ProtectedLayoutWarehouseLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutWarehouseLayoutRoute,
  } as any)
const ProtectedLayoutSupportLayoutIndexRoute =
  ProtectedLayoutSupportLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutSupportLayoutRoute,
  } as any)
const ProtectedLayoutSettingsLayoutIndexRoute =
  ProtectedLayoutSettingsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutSettingsLayoutRoute,
  } as any)
const ProtectedLayoutServiceContractsLayoutIndexRoute =
  ProtectedLayoutServiceContractsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutServiceContractsLayoutRoute,
  } as any)
const ProtectedLayoutRegistryLayoutIndexRoute =
  ProtectedLayoutRegistryLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutRegistryLayoutRoute,
  } as any)
const ProtectedLayoutProductsLayoutIndexRoute =
  ProtectedLayoutProductsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutProductsLayoutRoute,
  } as any)
const ProtectedLayoutPriceListsLayoutIndexRoute =
  ProtectedLayoutPriceListsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutPriceListsLayoutRoute,
  } as any)
const ProtectedLayoutPaymentsLayoutIndexRoute =
  ProtectedLayoutPaymentsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutPaymentsLayoutRoute,
  } as any)
const ProtectedLayoutOrdersLayoutIndexRoute =
  ProtectedLayoutOrdersLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutOrdersLayoutRoute,
  } as any)
const ProtectedLayoutMachinesLayoutIndexRoute =
  ProtectedLayoutMachinesLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutMachinesLayoutRoute,
  } as any)
const ProtectedLayoutMachineChecksLayoutIndexRoute =
  ProtectedLayoutMachineChecksLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutMachineChecksLayoutRoute,
  } as any)
const ProtectedLayoutInvoicesLayoutIndexRoute =
  ProtectedLayoutInvoicesLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutInvoicesLayoutRoute,
  } as any)
const ProtectedLayoutInventoryLayoutIndexRoute =
  ProtectedLayoutInventoryLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutInventoryLayoutRoute,
  } as any)
const ProtectedLayoutHotelLayoutIndexRoute =
  ProtectedLayoutHotelLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutHotelLayoutRoute,
  } as any)
const ProtectedLayoutHelpCategoryIndexRoute =
  ProtectedLayoutHelpCategoryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutHelpCategoryRoute,
  } as any)
const ProtectedLayoutForecastLayoutIndexRoute =
  ProtectedLayoutForecastLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutForecastLayoutRoute,
  } as any)
const ProtectedLayoutDocumentsLayoutIndexRoute =
  ProtectedLayoutDocumentsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutDocumentsLayoutRoute,
  } as any)
const ProtectedLayoutDocumentPaymentSchedulesLayoutIndexRoute =
  ProtectedLayoutDocumentPaymentSchedulesLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutDocumentPaymentSchedulesLayoutRoute,
  } as any)
const ProtectedLayoutDistinteRibaLayoutIndexRoute =
  ProtectedLayoutDistinteRibaLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutDistinteRibaLayoutRoute,
  } as any)
const ProtectedLayoutDeliveryNotesLayoutIndexRoute =
  ProtectedLayoutDeliveryNotesLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutDeliveryNotesLayoutRoute,
  } as any)
const ProtectedLayoutCommesseLayoutIndexRoute =
  ProtectedLayoutCommesseLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutCommesseLayoutRoute,
  } as any)
const ProtectedLayoutAdministrationLayoutIndexRoute =
  ProtectedLayoutAdministrationLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutAdministrationLayoutRoute,
  } as any)
const ProtectedLayoutAccountsLayoutIndexRoute =
  ProtectedLayoutAccountsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLayoutAccountsLayoutRoute,
  } as any)
const ProtectedLayoutWorkReportsLayoutNewRoute =
  ProtectedLayoutWorkReportsLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedLayoutWorkReportsLayoutRoute,
  } as any)
const ProtectedLayoutWorkReportsLayoutIdRoute =
  ProtectedLayoutWorkReportsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedLayoutWorkReportsLayoutRoute,
  } as any)
const ProtectedLayoutSupportLayoutNewRoute =
  ProtectedLayoutSupportLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedLayoutSupportLayoutRoute,
  } as any)
const ProtectedLayoutSupportLayoutIdRoute =
  ProtectedLayoutSupportLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedLayoutSupportLayoutRoute,
  } as any)
const ProtectedLayoutServiceContractsLayoutNewRoute =
  ProtectedLayoutServiceContractsLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedLayoutServiceContractsLayoutRoute,
  } as any)
const ProtectedLayoutServiceContractsLayoutIdRoute =
  ProtectedLayoutServiceContractsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedLayoutServiceContractsLayoutRoute,
  } as any)
const ProtectedLayoutProductsLayoutNewRoute =
  ProtectedLayoutProductsLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedLayoutProductsLayoutRoute,
  } as any)
const ProtectedLayoutProductsLayoutIdRoute =
  ProtectedLayoutProductsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedLayoutProductsLayoutRoute,
  } as any)
const ProtectedLayoutPriceListsLayoutNewRoute =
  ProtectedLayoutPriceListsLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedLayoutPriceListsLayoutRoute,
  } as any)
const ProtectedLayoutPriceListsLayoutIdRoute =
  ProtectedLayoutPriceListsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedLayoutPriceListsLayoutRoute,
  } as any)
const ProtectedLayoutOrdersLayoutNewRoute =
  ProtectedLayoutOrdersLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedLayoutOrdersLayoutRoute,
  } as any)
const ProtectedLayoutOrdersLayoutIdRoute =
  ProtectedLayoutOrdersLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedLayoutOrdersLayoutRoute,
  } as any)
const ProtectedLayoutMachinesLayoutNewRoute =
  ProtectedLayoutMachinesLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedLayoutMachinesLayoutRoute,
  } as any)
const ProtectedLayoutMachinesLayoutIdRoute =
  ProtectedLayoutMachinesLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedLayoutMachinesLayoutRoute,
  } as any)
const ProtectedLayoutInvoicesLayoutNewRoute =
  ProtectedLayoutInvoicesLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedLayoutInvoicesLayoutRoute,
  } as any)
const ProtectedLayoutInvoicesLayoutIdRoute =
  ProtectedLayoutInvoicesLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedLayoutInvoicesLayoutRoute,
  } as any)
const ProtectedLayoutInventoryLayoutNewRoute =
  ProtectedLayoutInventoryLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedLayoutInventoryLayoutRoute,
  } as any)
const ProtectedLayoutInventoryLayoutIdRoute =
  ProtectedLayoutInventoryLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedLayoutInventoryLayoutRoute,
  } as any)
const ProtectedLayoutHotelLayoutNewRoute =
  ProtectedLayoutHotelLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedLayoutHotelLayoutRoute,
  } as any)
const ProtectedLayoutHotelLayoutIdRoute =
  ProtectedLayoutHotelLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedLayoutHotelLayoutRoute,
  } as any)
const ProtectedLayoutHelpCategoryArticleRoute =
  ProtectedLayoutHelpCategoryArticleRouteImport.update({
    id: '/$article',
    path: '/$article',
    getParentRoute: () => ProtectedLayoutHelpCategoryRoute,
  } as any)
const ProtectedLayoutDocumentsLayoutNewRoute =
  ProtectedLayoutDocumentsLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedLayoutDocumentsLayoutRoute,
  } as any)
const ProtectedLayoutDocumentsLayoutIdRoute =
  ProtectedLayoutDocumentsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedLayoutDocumentsLayoutRoute,
  } as any)
const ProtectedLayoutDocumentPaymentSchedulesLayoutNewRoute =
  ProtectedLayoutDocumentPaymentSchedulesLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedLayoutDocumentPaymentSchedulesLayoutRoute,
  } as any)
const ProtectedLayoutDocumentPaymentSchedulesLayoutIdRoute =
  ProtectedLayoutDocumentPaymentSchedulesLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedLayoutDocumentPaymentSchedulesLayoutRoute,
  } as any)
const ProtectedLayoutDeliveryNotesLayoutNewRoute =
  ProtectedLayoutDeliveryNotesLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedLayoutDeliveryNotesLayoutRoute,
  } as any)
const ProtectedLayoutDeliveryNotesLayoutIdRoute =
  ProtectedLayoutDeliveryNotesLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedLayoutDeliveryNotesLayoutRoute,
  } as any)
const ProtectedLayoutCommesseLayoutNewRoute =
  ProtectedLayoutCommesseLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedLayoutCommesseLayoutRoute,
  } as any)
const ProtectedLayoutCommesseLayoutIdRoute =
  ProtectedLayoutCommesseLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedLayoutCommesseLayoutRoute,
  } as any)
const ProtectedLayoutAdministrationLayoutNewRoute =
  ProtectedLayoutAdministrationLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedLayoutAdministrationLayoutRoute,
  } as any)
const ProtectedLayoutAdministrationLayoutIdRoute =
  ProtectedLayoutAdministrationLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedLayoutAdministrationLayoutRoute,
  } as any)
const ProtectedLayoutAccountsLayoutNewRoute =
  ProtectedLayoutAccountsLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedLayoutAccountsLayoutRoute,
  } as any)
const ProtectedLayoutAccountsLayoutIdRoute =
  ProtectedLayoutAccountsLayoutIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedLayoutAccountsLayoutRoute,
  } as any)
const ProtectedLayoutSettingsLayoutUsersNewRoute =
  ProtectedLayoutSettingsLayoutUsersNewRouteImport.update({
    id: '/users/new',
    path: '/users/new',
    getParentRoute: () => ProtectedLayoutSettingsLayoutRoute,
  } as any)
const ProtectedLayoutSettingsLayoutUsersIdRoute =
  ProtectedLayoutSettingsLayoutUsersIdRouteImport.update({
    id: '/users/$id',
    path: '/users/$id',
    getParentRoute: () => ProtectedLayoutSettingsLayoutRoute,
  } as any)
const ProtectedLayoutSettingsLayoutCategoriesNewRoute =
  ProtectedLayoutSettingsLayoutCategoriesNewRouteImport.update({
    id: '/categories/new',
    path: '/categories/new',
    getParentRoute: () => ProtectedLayoutSettingsLayoutRoute,
  } as any)
const ProtectedLayoutSettingsLayoutCategoriesIdRoute =
  ProtectedLayoutSettingsLayoutCategoriesIdRouteImport.update({
    id: '/categories/$id',
    path: '/categories/$id',
    getParentRoute: () => ProtectedLayoutSettingsLayoutRoute,
  } as any)
const ProtectedLayoutRegistryLayoutProductsNewServiceRoute =
  ProtectedLayoutRegistryLayoutProductsNewServiceRouteImport.update({
    id: '/products/new-service',
    path: '/products/new-service',
    getParentRoute: () => ProtectedLayoutRegistryLayoutRoute,
  } as any)
const ProtectedLayoutRegistryLayoutProductsNewRoute =
  ProtectedLayoutRegistryLayoutProductsNewRouteImport.update({
    id: '/products/new',
    path: '/products/new',
    getParentRoute: () => ProtectedLayoutRegistryLayoutRoute,
  } as any)
const ProtectedLayoutRegistryLayoutProductsIdRoute =
  ProtectedLayoutRegistryLayoutProductsIdRouteImport.update({
    id: '/products/$id',
    path: '/products/$id',
    getParentRoute: () => ProtectedLayoutRegistryLayoutRoute,
  } as any)
const ProtectedLayoutRegistryLayoutEmployeesNewRoute =
  ProtectedLayoutRegistryLayoutEmployeesNewRouteImport.update({
    id: '/employees/new',
    path: '/employees/new',
    getParentRoute: () => ProtectedLayoutRegistryLayoutRoute,
  } as any)
const ProtectedLayoutRegistryLayoutEmployeesIdRoute =
  ProtectedLayoutRegistryLayoutEmployeesIdRouteImport.update({
    id: '/employees/$id',
    path: '/employees/$id',
    getParentRoute: () => ProtectedLayoutRegistryLayoutRoute,
  } as any)
const ProtectedLayoutRegistryLayoutCounterpartsNewRoute =
  ProtectedLayoutRegistryLayoutCounterpartsNewRouteImport.update({
    id: '/counterparts/new',
    path: '/counterparts/new',
    getParentRoute: () => ProtectedLayoutRegistryLayoutRoute,
  } as any)
const ProtectedLayoutRegistryLayoutCounterpartsIdRoute =
  ProtectedLayoutRegistryLayoutCounterpartsIdRouteImport.update({
    id: '/counterparts/$id',
    path: '/counterparts/$id',
    getParentRoute: () => ProtectedLayoutRegistryLayoutRoute,
  } as any)
const ProtectedLayoutPaymentsLayoutDocumentsIdRoute =
  ProtectedLayoutPaymentsLayoutDocumentsIdRouteImport.update({
    id: '/documents/$id',
    path: '/documents/$id',
    getParentRoute: () => ProtectedLayoutPaymentsLayoutRoute,
  } as any)
const ProtectedLayoutMachineChecksLayoutChecksIdRoute =
  ProtectedLayoutMachineChecksLayoutChecksIdRouteImport.update({
    id: '/checks/$id',
    path: '/checks/$id',
    getParentRoute: () => ProtectedLayoutMachineChecksLayoutRoute,
  } as any)
const ProtectedLayoutForecastLayoutRecurrencesNewRoute =
  ProtectedLayoutForecastLayoutRecurrencesNewRouteImport.update({
    id: '/recurrences/new',
    path: '/recurrences/new',
    getParentRoute: () => ProtectedLayoutForecastLayoutRoute,
  } as any)
const ProtectedLayoutForecastLayoutRecurrencesIdRoute =
  ProtectedLayoutForecastLayoutRecurrencesIdRouteImport.update({
    id: '/recurrences/$id',
    path: '/recurrences/$id',
    getParentRoute: () => ProtectedLayoutForecastLayoutRoute,
  } as any)
const ProtectedLayoutForecastLayoutPlanningNewRoute =
  ProtectedLayoutForecastLayoutPlanningNewRouteImport.update({
    id: '/planning/new',
    path: '/planning/new',
    getParentRoute: () => ProtectedLayoutForecastLayoutRoute,
  } as any)
const ProtectedLayoutForecastLayoutPlanningIdRoute =
  ProtectedLayoutForecastLayoutPlanningIdRouteImport.update({
    id: '/planning/$id',
    path: '/planning/$id',
    getParentRoute: () => ProtectedLayoutForecastLayoutRoute,
  } as any)
const ProtectedLayoutForecastLayoutForecastNewRoute =
  ProtectedLayoutForecastLayoutForecastNewRouteImport.update({
    id: '/forecast/new',
    path: '/forecast/new',
    getParentRoute: () => ProtectedLayoutForecastLayoutRoute,
  } as any)
const ProtectedLayoutForecastLayoutForecastIdRoute =
  ProtectedLayoutForecastLayoutForecastIdRouteImport.update({
    id: '/forecast/$id',
    path: '/forecast/$id',
    getParentRoute: () => ProtectedLayoutForecastLayoutRoute,
  } as any)
const ProtectedLayoutForecastLayoutDocumentIdRoute =
  ProtectedLayoutForecastLayoutDocumentIdRouteImport.update({
    id: '/document/$id',
    path: '/document/$id',
    getParentRoute: () => ProtectedLayoutForecastLayoutRoute,
  } as any)
const ProtectedLayoutForecastLayoutCashMovementIdRoute =
  ProtectedLayoutForecastLayoutCashMovementIdRouteImport.update({
    id: '/cash-movement/$id',
    path: '/cash-movement/$id',
    getParentRoute: () => ProtectedLayoutForecastLayoutRoute,
  } as any)
const ProtectedLayoutDocumentsLayoutDebtsNewRoute =
  ProtectedLayoutDocumentsLayoutDebtsNewRouteImport.update({
    id: '/debts/new',
    path: '/debts/new',
    getParentRoute: () => ProtectedLayoutDocumentsLayoutRoute,
  } as any)
const ProtectedLayoutDocumentsLayoutDebtsIdRoute =
  ProtectedLayoutDocumentsLayoutDebtsIdRouteImport.update({
    id: '/debts/$id',
    path: '/debts/$id',
    getParentRoute: () => ProtectedLayoutDocumentsLayoutRoute,
  } as any)
const ProtectedLayoutAccountsLayoutMovementsNewRoute =
  ProtectedLayoutAccountsLayoutMovementsNewRouteImport.update({
    id: '/movements/new',
    path: '/movements/new',
    getParentRoute: () => ProtectedLayoutAccountsLayoutRoute,
  } as any)
const ProtectedLayoutAccountsLayoutMovementsIdRoute =
  ProtectedLayoutAccountsLayoutMovementsIdRouteImport.update({
    id: '/movements/$id',
    path: '/movements/$id',
    getParentRoute: () => ProtectedLayoutAccountsLayoutRoute,
  } as any)
const ProtectedLayoutSettingsLayoutCategoriesIdKeywordsRoute =
  ProtectedLayoutSettingsLayoutCategoriesIdKeywordsRouteImport.update({
    id: '/keywords',
    path: '/keywords',
    getParentRoute: () => ProtectedLayoutSettingsLayoutCategoriesIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/protected': typeof ProtectedLayoutRouteRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/email-confirm': typeof EmailConfirmRoute
  '/impersonate': typeof ImpersonateRoute
  '/password-reset': typeof PasswordResetRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/studio': typeof StudioRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/contract/$token': typeof ContractTokenRoute
  '/d/wr/$token': typeof DWrTokenRoute
  '/protected/ai-chat': typeof ProtectedLayoutAiChatRoute
  '/protected/dashboard': typeof ProtectedLayoutDashboardRoute
  '/protected/help': typeof ProtectedLayoutHelpRouteWithChildren
  '/protected/to-invoice': typeof ProtectedLayoutToInvoiceRoute
  '/protected/': typeof ProtectedLayoutIndexRoute
  '/protected/accounts': typeof ProtectedLayoutAccountsLayoutRouteWithChildren
  '/protected/administration': typeof ProtectedLayoutAdministrationLayoutRouteWithChildren
  '/protected/commesse': typeof ProtectedLayoutCommesseLayoutRouteWithChildren
  '/protected/delivery-notes': typeof ProtectedLayoutDeliveryNotesLayoutRouteWithChildren
  '/protected/distinte-riba': typeof ProtectedLayoutDistinteRibaLayoutRouteWithChildren
  '/protected/document-payment-schedules': typeof ProtectedLayoutDocumentPaymentSchedulesLayoutRouteWithChildren
  '/protected/documents': typeof ProtectedLayoutDocumentsLayoutRouteWithChildren
  '/protected/forecast': typeof ProtectedLayoutForecastLayoutRouteWithChildren
  '/protected/help/$category': typeof ProtectedLayoutHelpCategoryRouteWithChildren
  '/protected/help/faq': typeof ProtectedLayoutHelpFaqRoute
  '/protected/hotel': typeof ProtectedLayoutHotelLayoutRouteWithChildren
  '/protected/inventory': typeof ProtectedLayoutInventoryLayoutRouteWithChildren
  '/protected/invoices': typeof ProtectedLayoutInvoicesLayoutRouteWithChildren
  '/protected/machine-checks': typeof ProtectedLayoutMachineChecksLayoutRouteWithChildren
  '/protected/machines': typeof ProtectedLayoutMachinesLayoutRouteWithChildren
  '/protected/orders': typeof ProtectedLayoutOrdersLayoutRouteWithChildren
  '/protected/payments': typeof ProtectedLayoutPaymentsLayoutRouteWithChildren
  '/protected/price-lists': typeof ProtectedLayoutPriceListsLayoutRouteWithChildren
  '/protected/products': typeof ProtectedLayoutProductsLayoutRouteWithChildren
  '/protected/registry': typeof ProtectedLayoutRegistryLayoutRouteWithChildren
  '/protected/service-contracts': typeof ProtectedLayoutServiceContractsLayoutRouteWithChildren
  '/protected/settings': typeof ProtectedLayoutSettingsLayoutRouteWithChildren
  '/protected/support': typeof ProtectedLayoutSupportLayoutRouteWithChildren
  '/protected/warehouse': typeof ProtectedLayoutWarehouseLayoutRouteWithChildren
  '/protected/work-reports': typeof ProtectedLayoutWorkReportsLayoutRouteWithChildren
  '/protected/help/': typeof ProtectedLayoutHelpIndexRoute
  '/protected/accounts/$id': typeof ProtectedLayoutAccountsLayoutIdRoute
  '/protected/accounts/new': typeof ProtectedLayoutAccountsLayoutNewRoute
  '/protected/administration/$id': typeof ProtectedLayoutAdministrationLayoutIdRoute
  '/protected/administration/new': typeof ProtectedLayoutAdministrationLayoutNewRoute
  '/protected/commesse/$id': typeof ProtectedLayoutCommesseLayoutIdRoute
  '/protected/commesse/new': typeof ProtectedLayoutCommesseLayoutNewRoute
  '/protected/delivery-notes/$id': typeof ProtectedLayoutDeliveryNotesLayoutIdRoute
  '/protected/delivery-notes/new': typeof ProtectedLayoutDeliveryNotesLayoutNewRoute
  '/protected/document-payment-schedules/$id': typeof ProtectedLayoutDocumentPaymentSchedulesLayoutIdRoute
  '/protected/document-payment-schedules/new': typeof ProtectedLayoutDocumentPaymentSchedulesLayoutNewRoute
  '/protected/documents/$id': typeof ProtectedLayoutDocumentsLayoutIdRoute
  '/protected/documents/new': typeof ProtectedLayoutDocumentsLayoutNewRoute
  '/protected/help/$category/$article': typeof ProtectedLayoutHelpCategoryArticleRoute
  '/protected/hotel/$id': typeof ProtectedLayoutHotelLayoutIdRoute
  '/protected/hotel/new': typeof ProtectedLayoutHotelLayoutNewRoute
  '/protected/inventory/$id': typeof ProtectedLayoutInventoryLayoutIdRoute
  '/protected/inventory/new': typeof ProtectedLayoutInventoryLayoutNewRoute
  '/protected/invoices/$id': typeof ProtectedLayoutInvoicesLayoutIdRoute
  '/protected/invoices/new': typeof ProtectedLayoutInvoicesLayoutNewRoute
  '/protected/machines/$id': typeof ProtectedLayoutMachinesLayoutIdRoute
  '/protected/machines/new': typeof ProtectedLayoutMachinesLayoutNewRoute
  '/protected/orders/$id': typeof ProtectedLayoutOrdersLayoutIdRoute
  '/protected/orders/new': typeof ProtectedLayoutOrdersLayoutNewRoute
  '/protected/price-lists/$id': typeof ProtectedLayoutPriceListsLayoutIdRoute
  '/protected/price-lists/new': typeof ProtectedLayoutPriceListsLayoutNewRoute
  '/protected/products/$id': typeof ProtectedLayoutProductsLayoutIdRoute
  '/protected/products/new': typeof ProtectedLayoutProductsLayoutNewRoute
  '/protected/service-contracts/$id': typeof ProtectedLayoutServiceContractsLayoutIdRoute
  '/protected/service-contracts/new': typeof ProtectedLayoutServiceContractsLayoutNewRoute
  '/protected/support/$id': typeof ProtectedLayoutSupportLayoutIdRoute
  '/protected/support/new': typeof ProtectedLayoutSupportLayoutNewRoute
  '/protected/work-reports/$id': typeof ProtectedLayoutWorkReportsLayoutIdRoute
  '/protected/work-reports/new': typeof ProtectedLayoutWorkReportsLayoutNewRoute
  '/protected/accounts/': typeof ProtectedLayoutAccountsLayoutIndexRoute
  '/protected/administration/': typeof ProtectedLayoutAdministrationLayoutIndexRoute
  '/protected/commesse/': typeof ProtectedLayoutCommesseLayoutIndexRoute
  '/protected/delivery-notes/': typeof ProtectedLayoutDeliveryNotesLayoutIndexRoute
  '/protected/distinte-riba/': typeof ProtectedLayoutDistinteRibaLayoutIndexRoute
  '/protected/document-payment-schedules/': typeof ProtectedLayoutDocumentPaymentSchedulesLayoutIndexRoute
  '/protected/documents/': typeof ProtectedLayoutDocumentsLayoutIndexRoute
  '/protected/forecast/': typeof ProtectedLayoutForecastLayoutIndexRoute
  '/protected/help/$category/': typeof ProtectedLayoutHelpCategoryIndexRoute
  '/protected/hotel/': typeof ProtectedLayoutHotelLayoutIndexRoute
  '/protected/inventory/': typeof ProtectedLayoutInventoryLayoutIndexRoute
  '/protected/invoices/': typeof ProtectedLayoutInvoicesLayoutIndexRoute
  '/protected/machine-checks/': typeof ProtectedLayoutMachineChecksLayoutIndexRoute
  '/protected/machines/': typeof ProtectedLayoutMachinesLayoutIndexRoute
  '/protected/orders/': typeof ProtectedLayoutOrdersLayoutIndexRoute
  '/protected/payments/': typeof ProtectedLayoutPaymentsLayoutIndexRoute
  '/protected/price-lists/': typeof ProtectedLayoutPriceListsLayoutIndexRoute
  '/protected/products/': typeof ProtectedLayoutProductsLayoutIndexRoute
  '/protected/registry/': typeof ProtectedLayoutRegistryLayoutIndexRoute
  '/protected/service-contracts/': typeof ProtectedLayoutServiceContractsLayoutIndexRoute
  '/protected/settings/': typeof ProtectedLayoutSettingsLayoutIndexRoute
  '/protected/support/': typeof ProtectedLayoutSupportLayoutIndexRoute
  '/protected/warehouse/': typeof ProtectedLayoutWarehouseLayoutIndexRoute
  '/protected/work-reports/': typeof ProtectedLayoutWorkReportsLayoutIndexRoute
  '/protected/accounts/movements/$id': typeof ProtectedLayoutAccountsLayoutMovementsIdRoute
  '/protected/accounts/movements/new': typeof ProtectedLayoutAccountsLayoutMovementsNewRoute
  '/protected/documents/debts/$id': typeof ProtectedLayoutDocumentsLayoutDebtsIdRoute
  '/protected/documents/debts/new': typeof ProtectedLayoutDocumentsLayoutDebtsNewRoute
  '/protected/forecast/cash-movement/$id': typeof ProtectedLayoutForecastLayoutCashMovementIdRoute
  '/protected/forecast/document/$id': typeof ProtectedLayoutForecastLayoutDocumentIdRoute
  '/protected/forecast/forecast/$id': typeof ProtectedLayoutForecastLayoutForecastIdRoute
  '/protected/forecast/forecast/new': typeof ProtectedLayoutForecastLayoutForecastNewRoute
  '/protected/forecast/planning/$id': typeof ProtectedLayoutForecastLayoutPlanningIdRoute
  '/protected/forecast/planning/new': typeof ProtectedLayoutForecastLayoutPlanningNewRoute
  '/protected/forecast/recurrences/$id': typeof ProtectedLayoutForecastLayoutRecurrencesIdRoute
  '/protected/forecast/recurrences/new': typeof ProtectedLayoutForecastLayoutRecurrencesNewRoute
  '/protected/machine-checks/checks/$id': typeof ProtectedLayoutMachineChecksLayoutChecksIdRoute
  '/protected/payments/documents/$id': typeof ProtectedLayoutPaymentsLayoutDocumentsIdRoute
  '/protected/registry/counterparts/$id': typeof ProtectedLayoutRegistryLayoutCounterpartsIdRoute
  '/protected/registry/counterparts/new': typeof ProtectedLayoutRegistryLayoutCounterpartsNewRoute
  '/protected/registry/employees/$id': typeof ProtectedLayoutRegistryLayoutEmployeesIdRoute
  '/protected/registry/employees/new': typeof ProtectedLayoutRegistryLayoutEmployeesNewRoute
  '/protected/registry/products/$id': typeof ProtectedLayoutRegistryLayoutProductsIdRoute
  '/protected/registry/products/new': typeof ProtectedLayoutRegistryLayoutProductsNewRoute
  '/protected/registry/products/new-service': typeof ProtectedLayoutRegistryLayoutProductsNewServiceRoute
  '/protected/settings/categories/$id': typeof ProtectedLayoutSettingsLayoutCategoriesIdRouteWithChildren
  '/protected/settings/categories/new': typeof ProtectedLayoutSettingsLayoutCategoriesNewRoute
  '/protected/settings/users/$id': typeof ProtectedLayoutSettingsLayoutUsersIdRoute
  '/protected/settings/users/new': typeof ProtectedLayoutSettingsLayoutUsersNewRoute
  '/protected/settings/categories/$id/keywords': typeof ProtectedLayoutSettingsLayoutCategoriesIdKeywordsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/protected': typeof ProtectedLayoutIndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/email-confirm': typeof EmailConfirmRoute
  '/impersonate': typeof ImpersonateRoute
  '/password-reset': typeof PasswordResetRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/studio': typeof StudioRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/contract/$token': typeof ContractTokenRoute
  '/d/wr/$token': typeof DWrTokenRoute
  '/protected/ai-chat': typeof ProtectedLayoutAiChatRoute
  '/protected/dashboard': typeof ProtectedLayoutDashboardRoute
  '/protected/to-invoice': typeof ProtectedLayoutToInvoiceRoute
  '/protected/accounts': typeof ProtectedLayoutAccountsLayoutIndexRoute
  '/protected/administration': typeof ProtectedLayoutAdministrationLayoutIndexRoute
  '/protected/commesse': typeof ProtectedLayoutCommesseLayoutIndexRoute
  '/protected/delivery-notes': typeof ProtectedLayoutDeliveryNotesLayoutIndexRoute
  '/protected/distinte-riba': typeof ProtectedLayoutDistinteRibaLayoutIndexRoute
  '/protected/document-payment-schedules': typeof ProtectedLayoutDocumentPaymentSchedulesLayoutIndexRoute
  '/protected/documents': typeof ProtectedLayoutDocumentsLayoutIndexRoute
  '/protected/forecast': typeof ProtectedLayoutForecastLayoutIndexRoute
  '/protected/help/faq': typeof ProtectedLayoutHelpFaqRoute
  '/protected/hotel': typeof ProtectedLayoutHotelLayoutIndexRoute
  '/protected/inventory': typeof ProtectedLayoutInventoryLayoutIndexRoute
  '/protected/invoices': typeof ProtectedLayoutInvoicesLayoutIndexRoute
  '/protected/machine-checks': typeof ProtectedLayoutMachineChecksLayoutIndexRoute
  '/protected/machines': typeof ProtectedLayoutMachinesLayoutIndexRoute
  '/protected/orders': typeof ProtectedLayoutOrdersLayoutIndexRoute
  '/protected/payments': typeof ProtectedLayoutPaymentsLayoutIndexRoute
  '/protected/price-lists': typeof ProtectedLayoutPriceListsLayoutIndexRoute
  '/protected/products': typeof ProtectedLayoutProductsLayoutIndexRoute
  '/protected/registry': typeof ProtectedLayoutRegistryLayoutIndexRoute
  '/protected/service-contracts': typeof ProtectedLayoutServiceContractsLayoutIndexRoute
  '/protected/settings': typeof ProtectedLayoutSettingsLayoutIndexRoute
  '/protected/support': typeof ProtectedLayoutSupportLayoutIndexRoute
  '/protected/warehouse': typeof ProtectedLayoutWarehouseLayoutIndexRoute
  '/protected/work-reports': typeof ProtectedLayoutWorkReportsLayoutIndexRoute
  '/protected/help': typeof ProtectedLayoutHelpIndexRoute
  '/protected/accounts/$id': typeof ProtectedLayoutAccountsLayoutIdRoute
  '/protected/accounts/new': typeof ProtectedLayoutAccountsLayoutNewRoute
  '/protected/administration/$id': typeof ProtectedLayoutAdministrationLayoutIdRoute
  '/protected/administration/new': typeof ProtectedLayoutAdministrationLayoutNewRoute
  '/protected/commesse/$id': typeof ProtectedLayoutCommesseLayoutIdRoute
  '/protected/commesse/new': typeof ProtectedLayoutCommesseLayoutNewRoute
  '/protected/delivery-notes/$id': typeof ProtectedLayoutDeliveryNotesLayoutIdRoute
  '/protected/delivery-notes/new': typeof ProtectedLayoutDeliveryNotesLayoutNewRoute
  '/protected/document-payment-schedules/$id': typeof ProtectedLayoutDocumentPaymentSchedulesLayoutIdRoute
  '/protected/document-payment-schedules/new': typeof ProtectedLayoutDocumentPaymentSchedulesLayoutNewRoute
  '/protected/documents/$id': typeof ProtectedLayoutDocumentsLayoutIdRoute
  '/protected/documents/new': typeof ProtectedLayoutDocumentsLayoutNewRoute
  '/protected/help/$category/$article': typeof ProtectedLayoutHelpCategoryArticleRoute
  '/protected/hotel/$id': typeof ProtectedLayoutHotelLayoutIdRoute
  '/protected/hotel/new': typeof ProtectedLayoutHotelLayoutNewRoute
  '/protected/inventory/$id': typeof ProtectedLayoutInventoryLayoutIdRoute
  '/protected/inventory/new': typeof ProtectedLayoutInventoryLayoutNewRoute
  '/protected/invoices/$id': typeof ProtectedLayoutInvoicesLayoutIdRoute
  '/protected/invoices/new': typeof ProtectedLayoutInvoicesLayoutNewRoute
  '/protected/machines/$id': typeof ProtectedLayoutMachinesLayoutIdRoute
  '/protected/machines/new': typeof ProtectedLayoutMachinesLayoutNewRoute
  '/protected/orders/$id': typeof ProtectedLayoutOrdersLayoutIdRoute
  '/protected/orders/new': typeof ProtectedLayoutOrdersLayoutNewRoute
  '/protected/price-lists/$id': typeof ProtectedLayoutPriceListsLayoutIdRoute
  '/protected/price-lists/new': typeof ProtectedLayoutPriceListsLayoutNewRoute
  '/protected/products/$id': typeof ProtectedLayoutProductsLayoutIdRoute
  '/protected/products/new': typeof ProtectedLayoutProductsLayoutNewRoute
  '/protected/service-contracts/$id': typeof ProtectedLayoutServiceContractsLayoutIdRoute
  '/protected/service-contracts/new': typeof ProtectedLayoutServiceContractsLayoutNewRoute
  '/protected/support/$id': typeof ProtectedLayoutSupportLayoutIdRoute
  '/protected/support/new': typeof ProtectedLayoutSupportLayoutNewRoute
  '/protected/work-reports/$id': typeof ProtectedLayoutWorkReportsLayoutIdRoute
  '/protected/work-reports/new': typeof ProtectedLayoutWorkReportsLayoutNewRoute
  '/protected/help/$category': typeof ProtectedLayoutHelpCategoryIndexRoute
  '/protected/accounts/movements/$id': typeof ProtectedLayoutAccountsLayoutMovementsIdRoute
  '/protected/accounts/movements/new': typeof ProtectedLayoutAccountsLayoutMovementsNewRoute
  '/protected/documents/debts/$id': typeof ProtectedLayoutDocumentsLayoutDebtsIdRoute
  '/protected/documents/debts/new': typeof ProtectedLayoutDocumentsLayoutDebtsNewRoute
  '/protected/forecast/cash-movement/$id': typeof ProtectedLayoutForecastLayoutCashMovementIdRoute
  '/protected/forecast/document/$id': typeof ProtectedLayoutForecastLayoutDocumentIdRoute
  '/protected/forecast/forecast/$id': typeof ProtectedLayoutForecastLayoutForecastIdRoute
  '/protected/forecast/forecast/new': typeof ProtectedLayoutForecastLayoutForecastNewRoute
  '/protected/forecast/planning/$id': typeof ProtectedLayoutForecastLayoutPlanningIdRoute
  '/protected/forecast/planning/new': typeof ProtectedLayoutForecastLayoutPlanningNewRoute
  '/protected/forecast/recurrences/$id': typeof ProtectedLayoutForecastLayoutRecurrencesIdRoute
  '/protected/forecast/recurrences/new': typeof ProtectedLayoutForecastLayoutRecurrencesNewRoute
  '/protected/machine-checks/checks/$id': typeof ProtectedLayoutMachineChecksLayoutChecksIdRoute
  '/protected/payments/documents/$id': typeof ProtectedLayoutPaymentsLayoutDocumentsIdRoute
  '/protected/registry/counterparts/$id': typeof ProtectedLayoutRegistryLayoutCounterpartsIdRoute
  '/protected/registry/counterparts/new': typeof ProtectedLayoutRegistryLayoutCounterpartsNewRoute
  '/protected/registry/employees/$id': typeof ProtectedLayoutRegistryLayoutEmployeesIdRoute
  '/protected/registry/employees/new': typeof ProtectedLayoutRegistryLayoutEmployeesNewRoute
  '/protected/registry/products/$id': typeof ProtectedLayoutRegistryLayoutProductsIdRoute
  '/protected/registry/products/new': typeof ProtectedLayoutRegistryLayoutProductsNewRoute
  '/protected/registry/products/new-service': typeof ProtectedLayoutRegistryLayoutProductsNewServiceRoute
  '/protected/settings/categories/$id': typeof ProtectedLayoutSettingsLayoutCategoriesIdRouteWithChildren
  '/protected/settings/categories/new': typeof ProtectedLayoutSettingsLayoutCategoriesNewRoute
  '/protected/settings/users/$id': typeof ProtectedLayoutSettingsLayoutUsersIdRoute
  '/protected/settings/users/new': typeof ProtectedLayoutSettingsLayoutUsersNewRoute
  '/protected/settings/categories/$id/keywords': typeof ProtectedLayoutSettingsLayoutCategoriesIdKeywordsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/protected': typeof ProtectedRouteRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/email-confirm': typeof EmailConfirmRoute
  '/impersonate': typeof ImpersonateRoute
  '/password-reset': typeof PasswordResetRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/studio': typeof StudioRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/protected/_layout': typeof ProtectedLayoutRouteRouteWithChildren
  '/contract/$token': typeof ContractTokenRoute
  '/d/wr/$token': typeof DWrTokenRoute
  '/protected/_layout/ai-chat': typeof ProtectedLayoutAiChatRoute
  '/protected/_layout/dashboard': typeof ProtectedLayoutDashboardRoute
  '/protected/_layout/help': typeof ProtectedLayoutHelpRouteWithChildren
  '/protected/_layout/to-invoice': typeof ProtectedLayoutToInvoiceRoute
  '/protected/_layout/': typeof ProtectedLayoutIndexRoute
  '/protected/_layout/accounts': typeof ProtectedLayoutAccountsRouteWithChildren
  '/protected/_layout/accounts/_layout': typeof ProtectedLayoutAccountsLayoutRouteWithChildren
  '/protected/_layout/administration': typeof ProtectedLayoutAdministrationRouteWithChildren
  '/protected/_layout/administration/_layout': typeof ProtectedLayoutAdministrationLayoutRouteWithChildren
  '/protected/_layout/commesse': typeof ProtectedLayoutCommesseRouteWithChildren
  '/protected/_layout/commesse/_layout': typeof ProtectedLayoutCommesseLayoutRouteWithChildren
  '/protected/_layout/delivery-notes': typeof ProtectedLayoutDeliveryNotesRouteWithChildren
  '/protected/_layout/delivery-notes/_layout': typeof ProtectedLayoutDeliveryNotesLayoutRouteWithChildren
  '/protected/_layout/distinte-riba': typeof ProtectedLayoutDistinteRibaRouteWithChildren
  '/protected/_layout/distinte-riba/_layout': typeof ProtectedLayoutDistinteRibaLayoutRouteWithChildren
  '/protected/_layout/document-payment-schedules': typeof ProtectedLayoutDocumentPaymentSchedulesRouteWithChildren
  '/protected/_layout/document-payment-schedules/_layout': typeof ProtectedLayoutDocumentPaymentSchedulesLayoutRouteWithChildren
  '/protected/_layout/documents': typeof ProtectedLayoutDocumentsRouteWithChildren
  '/protected/_layout/documents/_layout': typeof ProtectedLayoutDocumentsLayoutRouteWithChildren
  '/protected/_layout/forecast': typeof ProtectedLayoutForecastRouteWithChildren
  '/protected/_layout/forecast/_layout': typeof ProtectedLayoutForecastLayoutRouteWithChildren
  '/protected/_layout/help/$category': typeof ProtectedLayoutHelpCategoryRouteWithChildren
  '/protected/_layout/help/faq': typeof ProtectedLayoutHelpFaqRoute
  '/protected/_layout/hotel': typeof ProtectedLayoutHotelRouteWithChildren
  '/protected/_layout/hotel/_layout': typeof ProtectedLayoutHotelLayoutRouteWithChildren
  '/protected/_layout/inventory': typeof ProtectedLayoutInventoryRouteWithChildren
  '/protected/_layout/inventory/_layout': typeof ProtectedLayoutInventoryLayoutRouteWithChildren
  '/protected/_layout/invoices': typeof ProtectedLayoutInvoicesRouteWithChildren
  '/protected/_layout/invoices/_layout': typeof ProtectedLayoutInvoicesLayoutRouteWithChildren
  '/protected/_layout/machine-checks': typeof ProtectedLayoutMachineChecksRouteWithChildren
  '/protected/_layout/machine-checks/_layout': typeof ProtectedLayoutMachineChecksLayoutRouteWithChildren
  '/protected/_layout/machines': typeof ProtectedLayoutMachinesRouteWithChildren
  '/protected/_layout/machines/_layout': typeof ProtectedLayoutMachinesLayoutRouteWithChildren
  '/protected/_layout/orders': typeof ProtectedLayoutOrdersRouteWithChildren
  '/protected/_layout/orders/_layout': typeof ProtectedLayoutOrdersLayoutRouteWithChildren
  '/protected/_layout/payments': typeof ProtectedLayoutPaymentsRouteWithChildren
  '/protected/_layout/payments/_layout': typeof ProtectedLayoutPaymentsLayoutRouteWithChildren
  '/protected/_layout/price-lists': typeof ProtectedLayoutPriceListsRouteWithChildren
  '/protected/_layout/price-lists/_layout': typeof ProtectedLayoutPriceListsLayoutRouteWithChildren
  '/protected/_layout/products': typeof ProtectedLayoutProductsRouteWithChildren
  '/protected/_layout/products/_layout': typeof ProtectedLayoutProductsLayoutRouteWithChildren
  '/protected/_layout/registry': typeof ProtectedLayoutRegistryRouteWithChildren
  '/protected/_layout/registry/_layout': typeof ProtectedLayoutRegistryLayoutRouteWithChildren
  '/protected/_layout/service-contracts': typeof ProtectedLayoutServiceContractsRouteWithChildren
  '/protected/_layout/service-contracts/_layout': typeof ProtectedLayoutServiceContractsLayoutRouteWithChildren
  '/protected/_layout/settings': typeof ProtectedLayoutSettingsRouteWithChildren
  '/protected/_layout/settings/_layout': typeof ProtectedLayoutSettingsLayoutRouteWithChildren
  '/protected/_layout/support': typeof ProtectedLayoutSupportRouteWithChildren
  '/protected/_layout/support/_layout': typeof ProtectedLayoutSupportLayoutRouteWithChildren
  '/protected/_layout/warehouse': typeof ProtectedLayoutWarehouseRouteWithChildren
  '/protected/_layout/warehouse/_layout': typeof ProtectedLayoutWarehouseLayoutRouteWithChildren
  '/protected/_layout/work-reports': typeof ProtectedLayoutWorkReportsRouteWithChildren
  '/protected/_layout/work-reports/_layout': typeof ProtectedLayoutWorkReportsLayoutRouteWithChildren
  '/protected/_layout/help/': typeof ProtectedLayoutHelpIndexRoute
  '/protected/_layout/accounts/_layout/$id': typeof ProtectedLayoutAccountsLayoutIdRoute
  '/protected/_layout/accounts/_layout/new': typeof ProtectedLayoutAccountsLayoutNewRoute
  '/protected/_layout/administration/_layout/$id': typeof ProtectedLayoutAdministrationLayoutIdRoute
  '/protected/_layout/administration/_layout/new': typeof ProtectedLayoutAdministrationLayoutNewRoute
  '/protected/_layout/commesse/_layout/$id': typeof ProtectedLayoutCommesseLayoutIdRoute
  '/protected/_layout/commesse/_layout/new': typeof ProtectedLayoutCommesseLayoutNewRoute
  '/protected/_layout/delivery-notes/_layout/$id': typeof ProtectedLayoutDeliveryNotesLayoutIdRoute
  '/protected/_layout/delivery-notes/_layout/new': typeof ProtectedLayoutDeliveryNotesLayoutNewRoute
  '/protected/_layout/document-payment-schedules/_layout/$id': typeof ProtectedLayoutDocumentPaymentSchedulesLayoutIdRoute
  '/protected/_layout/document-payment-schedules/_layout/new': typeof ProtectedLayoutDocumentPaymentSchedulesLayoutNewRoute
  '/protected/_layout/documents/_layout/$id': typeof ProtectedLayoutDocumentsLayoutIdRoute
  '/protected/_layout/documents/_layout/new': typeof ProtectedLayoutDocumentsLayoutNewRoute
  '/protected/_layout/help/$category/$article': typeof ProtectedLayoutHelpCategoryArticleRoute
  '/protected/_layout/hotel/_layout/$id': typeof ProtectedLayoutHotelLayoutIdRoute
  '/protected/_layout/hotel/_layout/new': typeof ProtectedLayoutHotelLayoutNewRoute
  '/protected/_layout/inventory/_layout/$id': typeof ProtectedLayoutInventoryLayoutIdRoute
  '/protected/_layout/inventory/_layout/new': typeof ProtectedLayoutInventoryLayoutNewRoute
  '/protected/_layout/invoices/_layout/$id': typeof ProtectedLayoutInvoicesLayoutIdRoute
  '/protected/_layout/invoices/_layout/new': typeof ProtectedLayoutInvoicesLayoutNewRoute
  '/protected/_layout/machines/_layout/$id': typeof ProtectedLayoutMachinesLayoutIdRoute
  '/protected/_layout/machines/_layout/new': typeof ProtectedLayoutMachinesLayoutNewRoute
  '/protected/_layout/orders/_layout/$id': typeof ProtectedLayoutOrdersLayoutIdRoute
  '/protected/_layout/orders/_layout/new': typeof ProtectedLayoutOrdersLayoutNewRoute
  '/protected/_layout/price-lists/_layout/$id': typeof ProtectedLayoutPriceListsLayoutIdRoute
  '/protected/_layout/price-lists/_layout/new': typeof ProtectedLayoutPriceListsLayoutNewRoute
  '/protected/_layout/products/_layout/$id': typeof ProtectedLayoutProductsLayoutIdRoute
  '/protected/_layout/products/_layout/new': typeof ProtectedLayoutProductsLayoutNewRoute
  '/protected/_layout/service-contracts/_layout/$id': typeof ProtectedLayoutServiceContractsLayoutIdRoute
  '/protected/_layout/service-contracts/_layout/new': typeof ProtectedLayoutServiceContractsLayoutNewRoute
  '/protected/_layout/support/_layout/$id': typeof ProtectedLayoutSupportLayoutIdRoute
  '/protected/_layout/support/_layout/new': typeof ProtectedLayoutSupportLayoutNewRoute
  '/protected/_layout/work-reports/_layout/$id': typeof ProtectedLayoutWorkReportsLayoutIdRoute
  '/protected/_layout/work-reports/_layout/new': typeof ProtectedLayoutWorkReportsLayoutNewRoute
  '/protected/_layout/accounts/_layout/': typeof ProtectedLayoutAccountsLayoutIndexRoute
  '/protected/_layout/administration/_layout/': typeof ProtectedLayoutAdministrationLayoutIndexRoute
  '/protected/_layout/commesse/_layout/': typeof ProtectedLayoutCommesseLayoutIndexRoute
  '/protected/_layout/delivery-notes/_layout/': typeof ProtectedLayoutDeliveryNotesLayoutIndexRoute
  '/protected/_layout/distinte-riba/_layout/': typeof ProtectedLayoutDistinteRibaLayoutIndexRoute
  '/protected/_layout/document-payment-schedules/_layout/': typeof ProtectedLayoutDocumentPaymentSchedulesLayoutIndexRoute
  '/protected/_layout/documents/_layout/': typeof ProtectedLayoutDocumentsLayoutIndexRoute
  '/protected/_layout/forecast/_layout/': typeof ProtectedLayoutForecastLayoutIndexRoute
  '/protected/_layout/help/$category/': typeof ProtectedLayoutHelpCategoryIndexRoute
  '/protected/_layout/hotel/_layout/': typeof ProtectedLayoutHotelLayoutIndexRoute
  '/protected/_layout/inventory/_layout/': typeof ProtectedLayoutInventoryLayoutIndexRoute
  '/protected/_layout/invoices/_layout/': typeof ProtectedLayoutInvoicesLayoutIndexRoute
  '/protected/_layout/machine-checks/_layout/': typeof ProtectedLayoutMachineChecksLayoutIndexRoute
  '/protected/_layout/machines/_layout/': typeof ProtectedLayoutMachinesLayoutIndexRoute
  '/protected/_layout/orders/_layout/': typeof ProtectedLayoutOrdersLayoutIndexRoute
  '/protected/_layout/payments/_layout/': typeof ProtectedLayoutPaymentsLayoutIndexRoute
  '/protected/_layout/price-lists/_layout/': typeof ProtectedLayoutPriceListsLayoutIndexRoute
  '/protected/_layout/products/_layout/': typeof ProtectedLayoutProductsLayoutIndexRoute
  '/protected/_layout/registry/_layout/': typeof ProtectedLayoutRegistryLayoutIndexRoute
  '/protected/_layout/service-contracts/_layout/': typeof ProtectedLayoutServiceContractsLayoutIndexRoute
  '/protected/_layout/settings/_layout/': typeof ProtectedLayoutSettingsLayoutIndexRoute
  '/protected/_layout/support/_layout/': typeof ProtectedLayoutSupportLayoutIndexRoute
  '/protected/_layout/warehouse/_layout/': typeof ProtectedLayoutWarehouseLayoutIndexRoute
  '/protected/_layout/work-reports/_layout/': typeof ProtectedLayoutWorkReportsLayoutIndexRoute
  '/protected/_layout/accounts/_layout/movements/$id': typeof ProtectedLayoutAccountsLayoutMovementsIdRoute
  '/protected/_layout/accounts/_layout/movements/new': typeof ProtectedLayoutAccountsLayoutMovementsNewRoute
  '/protected/_layout/documents/_layout/debts/$id': typeof ProtectedLayoutDocumentsLayoutDebtsIdRoute
  '/protected/_layout/documents/_layout/debts/new': typeof ProtectedLayoutDocumentsLayoutDebtsNewRoute
  '/protected/_layout/forecast/_layout/cash-movement/$id': typeof ProtectedLayoutForecastLayoutCashMovementIdRoute
  '/protected/_layout/forecast/_layout/document/$id': typeof ProtectedLayoutForecastLayoutDocumentIdRoute
  '/protected/_layout/forecast/_layout/forecast/$id': typeof ProtectedLayoutForecastLayoutForecastIdRoute
  '/protected/_layout/forecast/_layout/forecast/new': typeof ProtectedLayoutForecastLayoutForecastNewRoute
  '/protected/_layout/forecast/_layout/planning/$id': typeof ProtectedLayoutForecastLayoutPlanningIdRoute
  '/protected/_layout/forecast/_layout/planning/new': typeof ProtectedLayoutForecastLayoutPlanningNewRoute
  '/protected/_layout/forecast/_layout/recurrences/$id': typeof ProtectedLayoutForecastLayoutRecurrencesIdRoute
  '/protected/_layout/forecast/_layout/recurrences/new': typeof ProtectedLayoutForecastLayoutRecurrencesNewRoute
  '/protected/_layout/machine-checks/_layout/checks/$id': typeof ProtectedLayoutMachineChecksLayoutChecksIdRoute
  '/protected/_layout/payments/_layout/documents/$id': typeof ProtectedLayoutPaymentsLayoutDocumentsIdRoute
  '/protected/_layout/registry/_layout/counterparts/$id': typeof ProtectedLayoutRegistryLayoutCounterpartsIdRoute
  '/protected/_layout/registry/_layout/counterparts/new': typeof ProtectedLayoutRegistryLayoutCounterpartsNewRoute
  '/protected/_layout/registry/_layout/employees/$id': typeof ProtectedLayoutRegistryLayoutEmployeesIdRoute
  '/protected/_layout/registry/_layout/employees/new': typeof ProtectedLayoutRegistryLayoutEmployeesNewRoute
  '/protected/_layout/registry/_layout/products/$id': typeof ProtectedLayoutRegistryLayoutProductsIdRoute
  '/protected/_layout/registry/_layout/products/new': typeof ProtectedLayoutRegistryLayoutProductsNewRoute
  '/protected/_layout/registry/_layout/products/new-service': typeof ProtectedLayoutRegistryLayoutProductsNewServiceRoute
  '/protected/_layout/settings/_layout/categories/$id': typeof ProtectedLayoutSettingsLayoutCategoriesIdRouteWithChildren
  '/protected/_layout/settings/_layout/categories/new': typeof ProtectedLayoutSettingsLayoutCategoriesNewRoute
  '/protected/_layout/settings/_layout/users/$id': typeof ProtectedLayoutSettingsLayoutUsersIdRoute
  '/protected/_layout/settings/_layout/users/new': typeof ProtectedLayoutSettingsLayoutUsersNewRoute
  '/protected/_layout/settings/_layout/categories/$id/keywords': typeof ProtectedLayoutSettingsLayoutCategoriesIdKeywordsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/protected'
    | '/accept-invitation'
    | '/email-confirm'
    | '/impersonate'
    | '/password-reset'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/studio'
    | '/terms'
    | '/verify-email'
    | '/contract/$token'
    | '/d/wr/$token'
    | '/protected/ai-chat'
    | '/protected/dashboard'
    | '/protected/help'
    | '/protected/to-invoice'
    | '/protected/'
    | '/protected/accounts'
    | '/protected/administration'
    | '/protected/commesse'
    | '/protected/delivery-notes'
    | '/protected/distinte-riba'
    | '/protected/document-payment-schedules'
    | '/protected/documents'
    | '/protected/forecast'
    | '/protected/help/$category'
    | '/protected/help/faq'
    | '/protected/hotel'
    | '/protected/inventory'
    | '/protected/invoices'
    | '/protected/machine-checks'
    | '/protected/machines'
    | '/protected/orders'
    | '/protected/payments'
    | '/protected/price-lists'
    | '/protected/products'
    | '/protected/registry'
    | '/protected/service-contracts'
    | '/protected/settings'
    | '/protected/support'
    | '/protected/warehouse'
    | '/protected/work-reports'
    | '/protected/help/'
    | '/protected/accounts/$id'
    | '/protected/accounts/new'
    | '/protected/administration/$id'
    | '/protected/administration/new'
    | '/protected/commesse/$id'
    | '/protected/commesse/new'
    | '/protected/delivery-notes/$id'
    | '/protected/delivery-notes/new'
    | '/protected/document-payment-schedules/$id'
    | '/protected/document-payment-schedules/new'
    | '/protected/documents/$id'
    | '/protected/documents/new'
    | '/protected/help/$category/$article'
    | '/protected/hotel/$id'
    | '/protected/hotel/new'
    | '/protected/inventory/$id'
    | '/protected/inventory/new'
    | '/protected/invoices/$id'
    | '/protected/invoices/new'
    | '/protected/machines/$id'
    | '/protected/machines/new'
    | '/protected/orders/$id'
    | '/protected/orders/new'
    | '/protected/price-lists/$id'
    | '/protected/price-lists/new'
    | '/protected/products/$id'
    | '/protected/products/new'
    | '/protected/service-contracts/$id'
    | '/protected/service-contracts/new'
    | '/protected/support/$id'
    | '/protected/support/new'
    | '/protected/work-reports/$id'
    | '/protected/work-reports/new'
    | '/protected/accounts/'
    | '/protected/administration/'
    | '/protected/commesse/'
    | '/protected/delivery-notes/'
    | '/protected/distinte-riba/'
    | '/protected/document-payment-schedules/'
    | '/protected/documents/'
    | '/protected/forecast/'
    | '/protected/help/$category/'
    | '/protected/hotel/'
    | '/protected/inventory/'
    | '/protected/invoices/'
    | '/protected/machine-checks/'
    | '/protected/machines/'
    | '/protected/orders/'
    | '/protected/payments/'
    | '/protected/price-lists/'
    | '/protected/products/'
    | '/protected/registry/'
    | '/protected/service-contracts/'
    | '/protected/settings/'
    | '/protected/support/'
    | '/protected/warehouse/'
    | '/protected/work-reports/'
    | '/protected/accounts/movements/$id'
    | '/protected/accounts/movements/new'
    | '/protected/documents/debts/$id'
    | '/protected/documents/debts/new'
    | '/protected/forecast/cash-movement/$id'
    | '/protected/forecast/document/$id'
    | '/protected/forecast/forecast/$id'
    | '/protected/forecast/forecast/new'
    | '/protected/forecast/planning/$id'
    | '/protected/forecast/planning/new'
    | '/protected/forecast/recurrences/$id'
    | '/protected/forecast/recurrences/new'
    | '/protected/machine-checks/checks/$id'
    | '/protected/payments/documents/$id'
    | '/protected/registry/counterparts/$id'
    | '/protected/registry/counterparts/new'
    | '/protected/registry/employees/$id'
    | '/protected/registry/employees/new'
    | '/protected/registry/products/$id'
    | '/protected/registry/products/new'
    | '/protected/registry/products/new-service'
    | '/protected/settings/categories/$id'
    | '/protected/settings/categories/new'
    | '/protected/settings/users/$id'
    | '/protected/settings/users/new'
    | '/protected/settings/categories/$id/keywords'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/protected'
    | '/accept-invitation'
    | '/email-confirm'
    | '/impersonate'
    | '/password-reset'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/studio'
    | '/terms'
    | '/verify-email'
    | '/contract/$token'
    | '/d/wr/$token'
    | '/protected/ai-chat'
    | '/protected/dashboard'
    | '/protected/to-invoice'
    | '/protected/accounts'
    | '/protected/administration'
    | '/protected/commesse'
    | '/protected/delivery-notes'
    | '/protected/distinte-riba'
    | '/protected/document-payment-schedules'
    | '/protected/documents'
    | '/protected/forecast'
    | '/protected/help/faq'
    | '/protected/hotel'
    | '/protected/inventory'
    | '/protected/invoices'
    | '/protected/machine-checks'
    | '/protected/machines'
    | '/protected/orders'
    | '/protected/payments'
    | '/protected/price-lists'
    | '/protected/products'
    | '/protected/registry'
    | '/protected/service-contracts'
    | '/protected/settings'
    | '/protected/support'
    | '/protected/warehouse'
    | '/protected/work-reports'
    | '/protected/help'
    | '/protected/accounts/$id'
    | '/protected/accounts/new'
    | '/protected/administration/$id'
    | '/protected/administration/new'
    | '/protected/commesse/$id'
    | '/protected/commesse/new'
    | '/protected/delivery-notes/$id'
    | '/protected/delivery-notes/new'
    | '/protected/document-payment-schedules/$id'
    | '/protected/document-payment-schedules/new'
    | '/protected/documents/$id'
    | '/protected/documents/new'
    | '/protected/help/$category/$article'
    | '/protected/hotel/$id'
    | '/protected/hotel/new'
    | '/protected/inventory/$id'
    | '/protected/inventory/new'
    | '/protected/invoices/$id'
    | '/protected/invoices/new'
    | '/protected/machines/$id'
    | '/protected/machines/new'
    | '/protected/orders/$id'
    | '/protected/orders/new'
    | '/protected/price-lists/$id'
    | '/protected/price-lists/new'
    | '/protected/products/$id'
    | '/protected/products/new'
    | '/protected/service-contracts/$id'
    | '/protected/service-contracts/new'
    | '/protected/support/$id'
    | '/protected/support/new'
    | '/protected/work-reports/$id'
    | '/protected/work-reports/new'
    | '/protected/help/$category'
    | '/protected/accounts/movements/$id'
    | '/protected/accounts/movements/new'
    | '/protected/documents/debts/$id'
    | '/protected/documents/debts/new'
    | '/protected/forecast/cash-movement/$id'
    | '/protected/forecast/document/$id'
    | '/protected/forecast/forecast/$id'
    | '/protected/forecast/forecast/new'
    | '/protected/forecast/planning/$id'
    | '/protected/forecast/planning/new'
    | '/protected/forecast/recurrences/$id'
    | '/protected/forecast/recurrences/new'
    | '/protected/machine-checks/checks/$id'
    | '/protected/payments/documents/$id'
    | '/protected/registry/counterparts/$id'
    | '/protected/registry/counterparts/new'
    | '/protected/registry/employees/$id'
    | '/protected/registry/employees/new'
    | '/protected/registry/products/$id'
    | '/protected/registry/products/new'
    | '/protected/registry/products/new-service'
    | '/protected/settings/categories/$id'
    | '/protected/settings/categories/new'
    | '/protected/settings/users/$id'
    | '/protected/settings/users/new'
    | '/protected/settings/categories/$id/keywords'
  id:
    | '__root__'
    | '/'
    | '/protected'
    | '/accept-invitation'
    | '/email-confirm'
    | '/impersonate'
    | '/password-reset'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/studio'
    | '/terms'
    | '/verify-email'
    | '/protected/_layout'
    | '/contract/$token'
    | '/d/wr/$token'
    | '/protected/_layout/ai-chat'
    | '/protected/_layout/dashboard'
    | '/protected/_layout/help'
    | '/protected/_layout/to-invoice'
    | '/protected/_layout/'
    | '/protected/_layout/accounts'
    | '/protected/_layout/accounts/_layout'
    | '/protected/_layout/administration'
    | '/protected/_layout/administration/_layout'
    | '/protected/_layout/commesse'
    | '/protected/_layout/commesse/_layout'
    | '/protected/_layout/delivery-notes'
    | '/protected/_layout/delivery-notes/_layout'
    | '/protected/_layout/distinte-riba'
    | '/protected/_layout/distinte-riba/_layout'
    | '/protected/_layout/document-payment-schedules'
    | '/protected/_layout/document-payment-schedules/_layout'
    | '/protected/_layout/documents'
    | '/protected/_layout/documents/_layout'
    | '/protected/_layout/forecast'
    | '/protected/_layout/forecast/_layout'
    | '/protected/_layout/help/$category'
    | '/protected/_layout/help/faq'
    | '/protected/_layout/hotel'
    | '/protected/_layout/hotel/_layout'
    | '/protected/_layout/inventory'
    | '/protected/_layout/inventory/_layout'
    | '/protected/_layout/invoices'
    | '/protected/_layout/invoices/_layout'
    | '/protected/_layout/machine-checks'
    | '/protected/_layout/machine-checks/_layout'
    | '/protected/_layout/machines'
    | '/protected/_layout/machines/_layout'
    | '/protected/_layout/orders'
    | '/protected/_layout/orders/_layout'
    | '/protected/_layout/payments'
    | '/protected/_layout/payments/_layout'
    | '/protected/_layout/price-lists'
    | '/protected/_layout/price-lists/_layout'
    | '/protected/_layout/products'
    | '/protected/_layout/products/_layout'
    | '/protected/_layout/registry'
    | '/protected/_layout/registry/_layout'
    | '/protected/_layout/service-contracts'
    | '/protected/_layout/service-contracts/_layout'
    | '/protected/_layout/settings'
    | '/protected/_layout/settings/_layout'
    | '/protected/_layout/support'
    | '/protected/_layout/support/_layout'
    | '/protected/_layout/warehouse'
    | '/protected/_layout/warehouse/_layout'
    | '/protected/_layout/work-reports'
    | '/protected/_layout/work-reports/_layout'
    | '/protected/_layout/help/'
    | '/protected/_layout/accounts/_layout/$id'
    | '/protected/_layout/accounts/_layout/new'
    | '/protected/_layout/administration/_layout/$id'
    | '/protected/_layout/administration/_layout/new'
    | '/protected/_layout/commesse/_layout/$id'
    | '/protected/_layout/commesse/_layout/new'
    | '/protected/_layout/delivery-notes/_layout/$id'
    | '/protected/_layout/delivery-notes/_layout/new'
    | '/protected/_layout/document-payment-schedules/_layout/$id'
    | '/protected/_layout/document-payment-schedules/_layout/new'
    | '/protected/_layout/documents/_layout/$id'
    | '/protected/_layout/documents/_layout/new'
    | '/protected/_layout/help/$category/$article'
    | '/protected/_layout/hotel/_layout/$id'
    | '/protected/_layout/hotel/_layout/new'
    | '/protected/_layout/inventory/_layout/$id'
    | '/protected/_layout/inventory/_layout/new'
    | '/protected/_layout/invoices/_layout/$id'
    | '/protected/_layout/invoices/_layout/new'
    | '/protected/_layout/machines/_layout/$id'
    | '/protected/_layout/machines/_layout/new'
    | '/protected/_layout/orders/_layout/$id'
    | '/protected/_layout/orders/_layout/new'
    | '/protected/_layout/price-lists/_layout/$id'
    | '/protected/_layout/price-lists/_layout/new'
    | '/protected/_layout/products/_layout/$id'
    | '/protected/_layout/products/_layout/new'
    | '/protected/_layout/service-contracts/_layout/$id'
    | '/protected/_layout/service-contracts/_layout/new'
    | '/protected/_layout/support/_layout/$id'
    | '/protected/_layout/support/_layout/new'
    | '/protected/_layout/work-reports/_layout/$id'
    | '/protected/_layout/work-reports/_layout/new'
    | '/protected/_layout/accounts/_layout/'
    | '/protected/_layout/administration/_layout/'
    | '/protected/_layout/commesse/_layout/'
    | '/protected/_layout/delivery-notes/_layout/'
    | '/protected/_layout/distinte-riba/_layout/'
    | '/protected/_layout/document-payment-schedules/_layout/'
    | '/protected/_layout/documents/_layout/'
    | '/protected/_layout/forecast/_layout/'
    | '/protected/_layout/help/$category/'
    | '/protected/_layout/hotel/_layout/'
    | '/protected/_layout/inventory/_layout/'
    | '/protected/_layout/invoices/_layout/'
    | '/protected/_layout/machine-checks/_layout/'
    | '/protected/_layout/machines/_layout/'
    | '/protected/_layout/orders/_layout/'
    | '/protected/_layout/payments/_layout/'
    | '/protected/_layout/price-lists/_layout/'
    | '/protected/_layout/products/_layout/'
    | '/protected/_layout/registry/_layout/'
    | '/protected/_layout/service-contracts/_layout/'
    | '/protected/_layout/settings/_layout/'
    | '/protected/_layout/support/_layout/'
    | '/protected/_layout/warehouse/_layout/'
    | '/protected/_layout/work-reports/_layout/'
    | '/protected/_layout/accounts/_layout/movements/$id'
    | '/protected/_layout/accounts/_layout/movements/new'
    | '/protected/_layout/documents/_layout/debts/$id'
    | '/protected/_layout/documents/_layout/debts/new'
    | '/protected/_layout/forecast/_layout/cash-movement/$id'
    | '/protected/_layout/forecast/_layout/document/$id'
    | '/protected/_layout/forecast/_layout/forecast/$id'
    | '/protected/_layout/forecast/_layout/forecast/new'
    | '/protected/_layout/forecast/_layout/planning/$id'
    | '/protected/_layout/forecast/_layout/planning/new'
    | '/protected/_layout/forecast/_layout/recurrences/$id'
    | '/protected/_layout/forecast/_layout/recurrences/new'
    | '/protected/_layout/machine-checks/_layout/checks/$id'
    | '/protected/_layout/payments/_layout/documents/$id'
    | '/protected/_layout/registry/_layout/counterparts/$id'
    | '/protected/_layout/registry/_layout/counterparts/new'
    | '/protected/_layout/registry/_layout/employees/$id'
    | '/protected/_layout/registry/_layout/employees/new'
    | '/protected/_layout/registry/_layout/products/$id'
    | '/protected/_layout/registry/_layout/products/new'
    | '/protected/_layout/registry/_layout/products/new-service'
    | '/protected/_layout/settings/_layout/categories/$id'
    | '/protected/_layout/settings/_layout/categories/new'
    | '/protected/_layout/settings/_layout/users/$id'
    | '/protected/_layout/settings/_layout/users/new'
    | '/protected/_layout/settings/_layout/categories/$id/keywords'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRouteRoute: typeof ProtectedRouteRouteWithChildren
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  EmailConfirmRoute: typeof EmailConfirmRoute
  ImpersonateRoute: typeof ImpersonateRoute
  PasswordResetRoute: typeof PasswordResetRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  StudioRoute: typeof StudioRoute
  TermsRoute: typeof TermsRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  ContractTokenRoute: typeof ContractTokenRoute
  DWrTokenRoute: typeof DWrTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio': {
      id: '/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof StudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset': {
      id: '/password-reset'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof PasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email-confirm': {
      id: '/email-confirm'
      path: '/email-confirm'
      fullPath: '/email-confirm'
      preLoaderRoute: typeof EmailConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/protected': {
      id: '/protected'
      path: '/protected'
      fullPath: '/protected'
      preLoaderRoute: typeof ProtectedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contract/$token': {
      id: '/contract/$token'
      path: '/contract/$token'
      fullPath: '/contract/$token'
      preLoaderRoute: typeof ContractTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/protected/_layout': {
      id: '/protected/_layout'
      path: ''
      fullPath: '/protected'
      preLoaderRoute: typeof ProtectedLayoutRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/protected/_layout/work-reports': {
      id: '/protected/_layout/work-reports'
      path: '/work-reports'
      fullPath: '/protected/work-reports'
      preLoaderRoute: typeof ProtectedLayoutWorkReportsRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/warehouse': {
      id: '/protected/_layout/warehouse'
      path: '/warehouse'
      fullPath: '/protected/warehouse'
      preLoaderRoute: typeof ProtectedLayoutWarehouseRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/support': {
      id: '/protected/_layout/support'
      path: '/support'
      fullPath: '/protected/support'
      preLoaderRoute: typeof ProtectedLayoutSupportRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/settings': {
      id: '/protected/_layout/settings'
      path: '/settings'
      fullPath: '/protected/settings'
      preLoaderRoute: typeof ProtectedLayoutSettingsRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/service-contracts': {
      id: '/protected/_layout/service-contracts'
      path: '/service-contracts'
      fullPath: '/protected/service-contracts'
      preLoaderRoute: typeof ProtectedLayoutServiceContractsRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/registry': {
      id: '/protected/_layout/registry'
      path: '/registry'
      fullPath: '/protected/registry'
      preLoaderRoute: typeof ProtectedLayoutRegistryRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/products': {
      id: '/protected/_layout/products'
      path: '/products'
      fullPath: '/protected/products'
      preLoaderRoute: typeof ProtectedLayoutProductsRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/price-lists': {
      id: '/protected/_layout/price-lists'
      path: '/price-lists'
      fullPath: '/protected/price-lists'
      preLoaderRoute: typeof ProtectedLayoutPriceListsRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/payments': {
      id: '/protected/_layout/payments'
      path: '/payments'
      fullPath: '/protected/payments'
      preLoaderRoute: typeof ProtectedLayoutPaymentsRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/orders': {
      id: '/protected/_layout/orders'
      path: '/orders'
      fullPath: '/protected/orders'
      preLoaderRoute: typeof ProtectedLayoutOrdersRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/machines': {
      id: '/protected/_layout/machines'
      path: '/machines'
      fullPath: '/protected/machines'
      preLoaderRoute: typeof ProtectedLayoutMachinesRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/machine-checks': {
      id: '/protected/_layout/machine-checks'
      path: '/machine-checks'
      fullPath: '/protected/machine-checks'
      preLoaderRoute: typeof ProtectedLayoutMachineChecksRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/invoices': {
      id: '/protected/_layout/invoices'
      path: '/invoices'
      fullPath: '/protected/invoices'
      preLoaderRoute: typeof ProtectedLayoutInvoicesRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/inventory': {
      id: '/protected/_layout/inventory'
      path: '/inventory'
      fullPath: '/protected/inventory'
      preLoaderRoute: typeof ProtectedLayoutInventoryRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/hotel': {
      id: '/protected/_layout/hotel'
      path: '/hotel'
      fullPath: '/protected/hotel'
      preLoaderRoute: typeof ProtectedLayoutHotelRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/forecast': {
      id: '/protected/_layout/forecast'
      path: '/forecast'
      fullPath: '/protected/forecast'
      preLoaderRoute: typeof ProtectedLayoutForecastRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/documents': {
      id: '/protected/_layout/documents'
      path: '/documents'
      fullPath: '/protected/documents'
      preLoaderRoute: typeof ProtectedLayoutDocumentsRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/document-payment-schedules': {
      id: '/protected/_layout/document-payment-schedules'
      path: '/document-payment-schedules'
      fullPath: '/protected/document-payment-schedules'
      preLoaderRoute: typeof ProtectedLayoutDocumentPaymentSchedulesRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/distinte-riba': {
      id: '/protected/_layout/distinte-riba'
      path: '/distinte-riba'
      fullPath: '/protected/distinte-riba'
      preLoaderRoute: typeof ProtectedLayoutDistinteRibaRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/delivery-notes': {
      id: '/protected/_layout/delivery-notes'
      path: '/delivery-notes'
      fullPath: '/protected/delivery-notes'
      preLoaderRoute: typeof ProtectedLayoutDeliveryNotesRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/commesse': {
      id: '/protected/_layout/commesse'
      path: '/commesse'
      fullPath: '/protected/commesse'
      preLoaderRoute: typeof ProtectedLayoutCommesseRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/administration': {
      id: '/protected/_layout/administration'
      path: '/administration'
      fullPath: '/protected/administration'
      preLoaderRoute: typeof ProtectedLayoutAdministrationRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/accounts': {
      id: '/protected/_layout/accounts'
      path: '/accounts'
      fullPath: '/protected/accounts'
      preLoaderRoute: typeof ProtectedLayoutAccountsRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/': {
      id: '/protected/_layout/'
      path: '/'
      fullPath: '/protected/'
      preLoaderRoute: typeof ProtectedLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/to-invoice': {
      id: '/protected/_layout/to-invoice'
      path: '/to-invoice'
      fullPath: '/protected/to-invoice'
      preLoaderRoute: typeof ProtectedLayoutToInvoiceRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/help': {
      id: '/protected/_layout/help'
      path: '/help'
      fullPath: '/protected/help'
      preLoaderRoute: typeof ProtectedLayoutHelpRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/dashboard': {
      id: '/protected/_layout/dashboard'
      path: '/dashboard'
      fullPath: '/protected/dashboard'
      preLoaderRoute: typeof ProtectedLayoutDashboardRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/protected/_layout/ai-chat': {
      id: '/protected/_layout/ai-chat'
      path: '/ai-chat'
      fullPath: '/protected/ai-chat'
      preLoaderRoute: typeof ProtectedLayoutAiChatRouteImport
      parentRoute: typeof ProtectedLayoutRouteRoute
    }
    '/d/wr/$token': {
      id: '/d/wr/$token'
      path: '/d/wr/$token'
      fullPath: '/d/wr/$token'
      preLoaderRoute: typeof DWrTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/protected/_layout/help/': {
      id: '/protected/_layout/help/'
      path: '/'
      fullPath: '/protected/help/'
      preLoaderRoute: typeof ProtectedLayoutHelpIndexRouteImport
      parentRoute: typeof ProtectedLayoutHelpRoute
    }
    '/protected/_layout/work-reports/_layout': {
      id: '/protected/_layout/work-reports/_layout'
      path: '/work-reports'
      fullPath: '/protected/work-reports'
      preLoaderRoute: typeof ProtectedLayoutWorkReportsLayoutRouteImport
      parentRoute: typeof ProtectedLayoutWorkReportsRoute
    }
    '/protected/_layout/warehouse/_layout': {
      id: '/protected/_layout/warehouse/_layout'
      path: '/warehouse'
      fullPath: '/protected/warehouse'
      preLoaderRoute: typeof ProtectedLayoutWarehouseLayoutRouteImport
      parentRoute: typeof ProtectedLayoutWarehouseRoute
    }
    '/protected/_layout/support/_layout': {
      id: '/protected/_layout/support/_layout'
      path: '/support'
      fullPath: '/protected/support'
      preLoaderRoute: typeof ProtectedLayoutSupportLayoutRouteImport
      parentRoute: typeof ProtectedLayoutSupportRoute
    }
    '/protected/_layout/settings/_layout': {
      id: '/protected/_layout/settings/_layout'
      path: '/settings'
      fullPath: '/protected/settings'
      preLoaderRoute: typeof ProtectedLayoutSettingsLayoutRouteImport
      parentRoute: typeof ProtectedLayoutSettingsRoute
    }
    '/protected/_layout/service-contracts/_layout': {
      id: '/protected/_layout/service-contracts/_layout'
      path: '/service-contracts'
      fullPath: '/protected/service-contracts'
      preLoaderRoute: typeof ProtectedLayoutServiceContractsLayoutRouteImport
      parentRoute: typeof ProtectedLayoutServiceContractsRoute
    }
    '/protected/_layout/registry/_layout': {
      id: '/protected/_layout/registry/_layout'
      path: '/registry'
      fullPath: '/protected/registry'
      preLoaderRoute: typeof ProtectedLayoutRegistryLayoutRouteImport
      parentRoute: typeof ProtectedLayoutRegistryRoute
    }
    '/protected/_layout/products/_layout': {
      id: '/protected/_layout/products/_layout'
      path: '/products'
      fullPath: '/protected/products'
      preLoaderRoute: typeof ProtectedLayoutProductsLayoutRouteImport
      parentRoute: typeof ProtectedLayoutProductsRoute
    }
    '/protected/_layout/price-lists/_layout': {
      id: '/protected/_layout/price-lists/_layout'
      path: '/price-lists'
      fullPath: '/protected/price-lists'
      preLoaderRoute: typeof ProtectedLayoutPriceListsLayoutRouteImport
      parentRoute: typeof ProtectedLayoutPriceListsRoute
    }
    '/protected/_layout/payments/_layout': {
      id: '/protected/_layout/payments/_layout'
      path: '/payments'
      fullPath: '/protected/payments'
      preLoaderRoute: typeof ProtectedLayoutPaymentsLayoutRouteImport
      parentRoute: typeof ProtectedLayoutPaymentsRoute
    }
    '/protected/_layout/orders/_layout': {
      id: '/protected/_layout/orders/_layout'
      path: '/orders'
      fullPath: '/protected/orders'
      preLoaderRoute: typeof ProtectedLayoutOrdersLayoutRouteImport
      parentRoute: typeof ProtectedLayoutOrdersRoute
    }
    '/protected/_layout/machines/_layout': {
      id: '/protected/_layout/machines/_layout'
      path: '/machines'
      fullPath: '/protected/machines'
      preLoaderRoute: typeof ProtectedLayoutMachinesLayoutRouteImport
      parentRoute: typeof ProtectedLayoutMachinesRoute
    }
    '/protected/_layout/machine-checks/_layout': {
      id: '/protected/_layout/machine-checks/_layout'
      path: '/machine-checks'
      fullPath: '/protected/machine-checks'
      preLoaderRoute: typeof ProtectedLayoutMachineChecksLayoutRouteImport
      parentRoute: typeof ProtectedLayoutMachineChecksRoute
    }
    '/protected/_layout/invoices/_layout': {
      id: '/protected/_layout/invoices/_layout'
      path: '/invoices'
      fullPath: '/protected/invoices'
      preLoaderRoute: typeof ProtectedLayoutInvoicesLayoutRouteImport
      parentRoute: typeof ProtectedLayoutInvoicesRoute
    }
    '/protected/_layout/inventory/_layout': {
      id: '/protected/_layout/inventory/_layout'
      path: '/inventory'
      fullPath: '/protected/inventory'
      preLoaderRoute: typeof ProtectedLayoutInventoryLayoutRouteImport
      parentRoute: typeof ProtectedLayoutInventoryRoute
    }
    '/protected/_layout/hotel/_layout': {
      id: '/protected/_layout/hotel/_layout'
      path: '/hotel'
      fullPath: '/protected/hotel'
      preLoaderRoute: typeof ProtectedLayoutHotelLayoutRouteImport
      parentRoute: typeof ProtectedLayoutHotelRoute
    }
    '/protected/_layout/help/faq': {
      id: '/protected/_layout/help/faq'
      path: '/faq'
      fullPath: '/protected/help/faq'
      preLoaderRoute: typeof ProtectedLayoutHelpFaqRouteImport
      parentRoute: typeof ProtectedLayoutHelpRoute
    }
    '/protected/_layout/help/$category': {
      id: '/protected/_layout/help/$category'
      path: '/$category'
      fullPath: '/protected/help/$category'
      preLoaderRoute: typeof ProtectedLayoutHelpCategoryRouteImport
      parentRoute: typeof ProtectedLayoutHelpRoute
    }
    '/protected/_layout/forecast/_layout': {
      id: '/protected/_layout/forecast/_layout'
      path: '/forecast'
      fullPath: '/protected/forecast'
      preLoaderRoute: typeof ProtectedLayoutForecastLayoutRouteImport
      parentRoute: typeof ProtectedLayoutForecastRoute
    }
    '/protected/_layout/documents/_layout': {
      id: '/protected/_layout/documents/_layout'
      path: '/documents'
      fullPath: '/protected/documents'
      preLoaderRoute: typeof ProtectedLayoutDocumentsLayoutRouteImport
      parentRoute: typeof ProtectedLayoutDocumentsRoute
    }
    '/protected/_layout/document-payment-schedules/_layout': {
      id: '/protected/_layout/document-payment-schedules/_layout'
      path: '/document-payment-schedules'
      fullPath: '/protected/document-payment-schedules'
      preLoaderRoute: typeof ProtectedLayoutDocumentPaymentSchedulesLayoutRouteImport
      parentRoute: typeof ProtectedLayoutDocumentPaymentSchedulesRoute
    }
    '/protected/_layout/distinte-riba/_layout': {
      id: '/protected/_layout/distinte-riba/_layout'
      path: '/distinte-riba'
      fullPath: '/protected/distinte-riba'
      preLoaderRoute: typeof ProtectedLayoutDistinteRibaLayoutRouteImport
      parentRoute: typeof ProtectedLayoutDistinteRibaRoute
    }
    '/protected/_layout/delivery-notes/_layout': {
      id: '/protected/_layout/delivery-notes/_layout'
      path: '/delivery-notes'
      fullPath: '/protected/delivery-notes'
      preLoaderRoute: typeof ProtectedLayoutDeliveryNotesLayoutRouteImport
      parentRoute: typeof ProtectedLayoutDeliveryNotesRoute
    }
    '/protected/_layout/commesse/_layout': {
      id: '/protected/_layout/commesse/_layout'
      path: '/commesse'
      fullPath: '/protected/commesse'
      preLoaderRoute: typeof ProtectedLayoutCommesseLayoutRouteImport
      parentRoute: typeof ProtectedLayoutCommesseRoute
    }
    '/protected/_layout/administration/_layout': {
      id: '/protected/_layout/administration/_layout'
      path: '/administration'
      fullPath: '/protected/administration'
      preLoaderRoute: typeof ProtectedLayoutAdministrationLayoutRouteImport
      parentRoute: typeof ProtectedLayoutAdministrationRoute
    }
    '/protected/_layout/accounts/_layout': {
      id: '/protected/_layout/accounts/_layout'
      path: '/accounts'
      fullPath: '/protected/accounts'
      preLoaderRoute: typeof ProtectedLayoutAccountsLayoutRouteImport
      parentRoute: typeof ProtectedLayoutAccountsRoute
    }
    '/protected/_layout/work-reports/_layout/': {
      id: '/protected/_layout/work-reports/_layout/'
      path: '/'
      fullPath: '/protected/work-reports/'
      preLoaderRoute: typeof ProtectedLayoutWorkReportsLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutWorkReportsLayoutRoute
    }
    '/protected/_layout/warehouse/_layout/': {
      id: '/protected/_layout/warehouse/_layout/'
      path: '/'
      fullPath: '/protected/warehouse/'
      preLoaderRoute: typeof ProtectedLayoutWarehouseLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutWarehouseLayoutRoute
    }
    '/protected/_layout/support/_layout/': {
      id: '/protected/_layout/support/_layout/'
      path: '/'
      fullPath: '/protected/support/'
      preLoaderRoute: typeof ProtectedLayoutSupportLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutSupportLayoutRoute
    }
    '/protected/_layout/settings/_layout/': {
      id: '/protected/_layout/settings/_layout/'
      path: '/'
      fullPath: '/protected/settings/'
      preLoaderRoute: typeof ProtectedLayoutSettingsLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutSettingsLayoutRoute
    }
    '/protected/_layout/service-contracts/_layout/': {
      id: '/protected/_layout/service-contracts/_layout/'
      path: '/'
      fullPath: '/protected/service-contracts/'
      preLoaderRoute: typeof ProtectedLayoutServiceContractsLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutServiceContractsLayoutRoute
    }
    '/protected/_layout/registry/_layout/': {
      id: '/protected/_layout/registry/_layout/'
      path: '/'
      fullPath: '/protected/registry/'
      preLoaderRoute: typeof ProtectedLayoutRegistryLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutRegistryLayoutRoute
    }
    '/protected/_layout/products/_layout/': {
      id: '/protected/_layout/products/_layout/'
      path: '/'
      fullPath: '/protected/products/'
      preLoaderRoute: typeof ProtectedLayoutProductsLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutProductsLayoutRoute
    }
    '/protected/_layout/price-lists/_layout/': {
      id: '/protected/_layout/price-lists/_layout/'
      path: '/'
      fullPath: '/protected/price-lists/'
      preLoaderRoute: typeof ProtectedLayoutPriceListsLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutPriceListsLayoutRoute
    }
    '/protected/_layout/payments/_layout/': {
      id: '/protected/_layout/payments/_layout/'
      path: '/'
      fullPath: '/protected/payments/'
      preLoaderRoute: typeof ProtectedLayoutPaymentsLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutPaymentsLayoutRoute
    }
    '/protected/_layout/orders/_layout/': {
      id: '/protected/_layout/orders/_layout/'
      path: '/'
      fullPath: '/protected/orders/'
      preLoaderRoute: typeof ProtectedLayoutOrdersLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutOrdersLayoutRoute
    }
    '/protected/_layout/machines/_layout/': {
      id: '/protected/_layout/machines/_layout/'
      path: '/'
      fullPath: '/protected/machines/'
      preLoaderRoute: typeof ProtectedLayoutMachinesLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutMachinesLayoutRoute
    }
    '/protected/_layout/machine-checks/_layout/': {
      id: '/protected/_layout/machine-checks/_layout/'
      path: '/'
      fullPath: '/protected/machine-checks/'
      preLoaderRoute: typeof ProtectedLayoutMachineChecksLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutMachineChecksLayoutRoute
    }
    '/protected/_layout/invoices/_layout/': {
      id: '/protected/_layout/invoices/_layout/'
      path: '/'
      fullPath: '/protected/invoices/'
      preLoaderRoute: typeof ProtectedLayoutInvoicesLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutInvoicesLayoutRoute
    }
    '/protected/_layout/inventory/_layout/': {
      id: '/protected/_layout/inventory/_layout/'
      path: '/'
      fullPath: '/protected/inventory/'
      preLoaderRoute: typeof ProtectedLayoutInventoryLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutInventoryLayoutRoute
    }
    '/protected/_layout/hotel/_layout/': {
      id: '/protected/_layout/hotel/_layout/'
      path: '/'
      fullPath: '/protected/hotel/'
      preLoaderRoute: typeof ProtectedLayoutHotelLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutHotelLayoutRoute
    }
    '/protected/_layout/help/$category/': {
      id: '/protected/_layout/help/$category/'
      path: '/'
      fullPath: '/protected/help/$category/'
      preLoaderRoute: typeof ProtectedLayoutHelpCategoryIndexRouteImport
      parentRoute: typeof ProtectedLayoutHelpCategoryRoute
    }
    '/protected/_layout/forecast/_layout/': {
      id: '/protected/_layout/forecast/_layout/'
      path: '/'
      fullPath: '/protected/forecast/'
      preLoaderRoute: typeof ProtectedLayoutForecastLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutForecastLayoutRoute
    }
    '/protected/_layout/documents/_layout/': {
      id: '/protected/_layout/documents/_layout/'
      path: '/'
      fullPath: '/protected/documents/'
      preLoaderRoute: typeof ProtectedLayoutDocumentsLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutDocumentsLayoutRoute
    }
    '/protected/_layout/document-payment-schedules/_layout/': {
      id: '/protected/_layout/document-payment-schedules/_layout/'
      path: '/'
      fullPath: '/protected/document-payment-schedules/'
      preLoaderRoute: typeof ProtectedLayoutDocumentPaymentSchedulesLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutDocumentPaymentSchedulesLayoutRoute
    }
    '/protected/_layout/distinte-riba/_layout/': {
      id: '/protected/_layout/distinte-riba/_layout/'
      path: '/'
      fullPath: '/protected/distinte-riba/'
      preLoaderRoute: typeof ProtectedLayoutDistinteRibaLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutDistinteRibaLayoutRoute
    }
    '/protected/_layout/delivery-notes/_layout/': {
      id: '/protected/_layout/delivery-notes/_layout/'
      path: '/'
      fullPath: '/protected/delivery-notes/'
      preLoaderRoute: typeof ProtectedLayoutDeliveryNotesLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutDeliveryNotesLayoutRoute
    }
    '/protected/_layout/commesse/_layout/': {
      id: '/protected/_layout/commesse/_layout/'
      path: '/'
      fullPath: '/protected/commesse/'
      preLoaderRoute: typeof ProtectedLayoutCommesseLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutCommesseLayoutRoute
    }
    '/protected/_layout/administration/_layout/': {
      id: '/protected/_layout/administration/_layout/'
      path: '/'
      fullPath: '/protected/administration/'
      preLoaderRoute: typeof ProtectedLayoutAdministrationLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutAdministrationLayoutRoute
    }
    '/protected/_layout/accounts/_layout/': {
      id: '/protected/_layout/accounts/_layout/'
      path: '/'
      fullPath: '/protected/accounts/'
      preLoaderRoute: typeof ProtectedLayoutAccountsLayoutIndexRouteImport
      parentRoute: typeof ProtectedLayoutAccountsLayoutRoute
    }
    '/protected/_layout/work-reports/_layout/new': {
      id: '/protected/_layout/work-reports/_layout/new'
      path: '/new'
      fullPath: '/protected/work-reports/new'
      preLoaderRoute: typeof ProtectedLayoutWorkReportsLayoutNewRouteImport
      parentRoute: typeof ProtectedLayoutWorkReportsLayoutRoute
    }
    '/protected/_layout/work-reports/_layout/$id': {
      id: '/protected/_layout/work-reports/_layout/$id'
      path: '/$id'
      fullPath: '/protected/work-reports/$id'
      preLoaderRoute: typeof ProtectedLayoutWorkReportsLayoutIdRouteImport
      parentRoute: typeof ProtectedLayoutWorkReportsLayoutRoute
    }
    '/protected/_layout/support/_layout/new': {
      id: '/protected/_layout/support/_layout/new'
      path: '/new'
      fullPath: '/protected/support/new'
      preLoaderRoute: typeof ProtectedLayoutSupportLayoutNewRouteImport
      parentRoute: typeof ProtectedLayoutSupportLayoutRoute
    }
    '/protected/_layout/support/_layout/$id': {
      id: '/protected/_layout/support/_layout/$id'
      path: '/$id'
      fullPath: '/protected/support/$id'
      preLoaderRoute: typeof ProtectedLayoutSupportLayoutIdRouteImport
      parentRoute: typeof ProtectedLayoutSupportLayoutRoute
    }
    '/protected/_layout/service-contracts/_layout/new': {
      id: '/protected/_layout/service-contracts/_layout/new'
      path: '/new'
      fullPath: '/protected/service-contracts/new'
      preLoaderRoute: typeof ProtectedLayoutServiceContractsLayoutNewRouteImport
      parentRoute: typeof ProtectedLayoutServiceContractsLayoutRoute
    }
    '/protected/_layout/service-contracts/_layout/$id': {
      id: '/protected/_layout/service-contracts/_layout/$id'
      path: '/$id'
      fullPath: '/protected/service-contracts/$id'
      preLoaderRoute: typeof ProtectedLayoutServiceContractsLayoutIdRouteImport
      parentRoute: typeof ProtectedLayoutServiceContractsLayoutRoute
    }
    '/protected/_layout/products/_layout/new': {
      id: '/protected/_layout/products/_layout/new'
      path: '/new'
      fullPath: '/protected/products/new'
      preLoaderRoute: typeof ProtectedLayoutProductsLayoutNewRouteImport
      parentRoute: typeof ProtectedLayoutProductsLayoutRoute
    }
    '/protected/_layout/products/_layout/$id': {
      id: '/protected/_layout/products/_layout/$id'
      path: '/$id'
      fullPath: '/protected/products/$id'
      preLoaderRoute: typeof ProtectedLayoutProductsLayoutIdRouteImport
      parentRoute: typeof ProtectedLayoutProductsLayoutRoute
    }
    '/protected/_layout/price-lists/_layout/new': {
      id: '/protected/_layout/price-lists/_layout/new'
      path: '/new'
      fullPath: '/protected/price-lists/new'
      preLoaderRoute: typeof ProtectedLayoutPriceListsLayoutNewRouteImport
      parentRoute: typeof ProtectedLayoutPriceListsLayoutRoute
    }
    '/protected/_layout/price-lists/_layout/$id': {
      id: '/protected/_layout/price-lists/_layout/$id'
      path: '/$id'
      fullPath: '/protected/price-lists/$id'
      preLoaderRoute: typeof ProtectedLayoutPriceListsLayoutIdRouteImport
      parentRoute: typeof ProtectedLayoutPriceListsLayoutRoute
    }
    '/protected/_layout/orders/_layout/new': {
      id: '/protected/_layout/orders/_layout/new'
      path: '/new'
      fullPath: '/protected/orders/new'
      preLoaderRoute: typeof ProtectedLayoutOrdersLayoutNewRouteImport
      parentRoute: typeof ProtectedLayoutOrdersLayoutRoute
    }
    '/protected/_layout/orders/_layout/$id': {
      id: '/protected/_layout/orders/_layout/$id'
      path: '/$id'
      fullPath: '/protected/orders/$id'
      preLoaderRoute: typeof ProtectedLayoutOrdersLayoutIdRouteImport
      parentRoute: typeof ProtectedLayoutOrdersLayoutRoute
    }
    '/protected/_layout/machines/_layout/new': {
      id: '/protected/_layout/machines/_layout/new'
      path: '/new'
      fullPath: '/protected/machines/new'
      preLoaderRoute: typeof ProtectedLayoutMachinesLayoutNewRouteImport
      parentRoute: typeof ProtectedLayoutMachinesLayoutRoute
    }
    '/protected/_layout/machines/_layout/$id': {
      id: '/protected/_layout/machines/_layout/$id'
      path: '/$id'
      fullPath: '/protected/machines/$id'
      preLoaderRoute: typeof ProtectedLayoutMachinesLayoutIdRouteImport
      parentRoute: typeof ProtectedLayoutMachinesLayoutRoute
    }
    '/protected/_layout/invoices/_layout/new': {
      id: '/protected/_layout/invoices/_layout/new'
      path: '/new'
      fullPath: '/protected/invoices/new'
      preLoaderRoute: typeof ProtectedLayoutInvoicesLayoutNewRouteImport
      parentRoute: typeof ProtectedLayoutInvoicesLayoutRoute
    }
    '/protected/_layout/invoices/_layout/$id': {
      id: '/protected/_layout/invoices/_layout/$id'
      path: '/$id'
      fullPath: '/protected/invoices/$id'
      preLoaderRoute: typeof ProtectedLayoutInvoicesLayoutIdRouteImport
      parentRoute: typeof ProtectedLayoutInvoicesLayoutRoute
    }
    '/protected/_layout/inventory/_layout/new': {
      id: '/protected/_layout/inventory/_layout/new'
      path: '/new'
      fullPath: '/protected/inventory/new'
      preLoaderRoute: typeof ProtectedLayoutInventoryLayoutNewRouteImport
      parentRoute: typeof ProtectedLayoutInventoryLayoutRoute
    }
    '/protected/_layout/inventory/_layout/$id': {
      id: '/protected/_layout/inventory/_layout/$id'
      path: '/$id'
      fullPath: '/protected/inventory/$id'
      preLoaderRoute: typeof ProtectedLayoutInventoryLayoutIdRouteImport
      parentRoute: typeof ProtectedLayoutInventoryLayoutRoute
    }
    '/protected/_layout/hotel/_layout/new': {
      id: '/protected/_layout/hotel/_layout/new'
      path: '/new'
      fullPath: '/protected/hotel/new'
      preLoaderRoute: typeof ProtectedLayoutHotelLayoutNewRouteImport
      parentRoute: typeof ProtectedLayoutHotelLayoutRoute
    }
    '/protected/_layout/hotel/_layout/$id': {
      id: '/protected/_layout/hotel/_layout/$id'
      path: '/$id'
      fullPath: '/protected/hotel/$id'
      preLoaderRoute: typeof ProtectedLayoutHotelLayoutIdRouteImport
      parentRoute: typeof ProtectedLayoutHotelLayoutRoute
    }
    '/protected/_layout/help/$category/$article': {
      id: '/protected/_layout/help/$category/$article'
      path: '/$article'
      fullPath: '/protected/help/$category/$article'
      preLoaderRoute: typeof ProtectedLayoutHelpCategoryArticleRouteImport
      parentRoute: typeof ProtectedLayoutHelpCategoryRoute
    }
    '/protected/_layout/documents/_layout/new': {
      id: '/protected/_layout/documents/_layout/new'
      path: '/new'
      fullPath: '/protected/documents/new'
      preLoaderRoute: typeof ProtectedLayoutDocumentsLayoutNewRouteImport
      parentRoute: typeof ProtectedLayoutDocumentsLayoutRoute
    }
    '/protected/_layout/documents/_layout/$id': {
      id: '/protected/_layout/documents/_layout/$id'
      path: '/$id'
      fullPath: '/protected/documents/$id'
      preLoaderRoute: typeof ProtectedLayoutDocumentsLayoutIdRouteImport
      parentRoute: typeof ProtectedLayoutDocumentsLayoutRoute
    }
    '/protected/_layout/document-payment-schedules/_layout/new': {
      id: '/protected/_layout/document-payment-schedules/_layout/new'
      path: '/new'
      fullPath: '/protected/document-payment-schedules/new'
      preLoaderRoute: typeof ProtectedLayoutDocumentPaymentSchedulesLayoutNewRouteImport
      parentRoute: typeof ProtectedLayoutDocumentPaymentSchedulesLayoutRoute
    }
    '/protected/_layout/document-payment-schedules/_layout/$id': {
      id: '/protected/_layout/document-payment-schedules/_layout/$id'
      path: '/$id'
      fullPath: '/protected/document-payment-schedules/$id'
      preLoaderRoute: typeof ProtectedLayoutDocumentPaymentSchedulesLayoutIdRouteImport
      parentRoute: typeof ProtectedLayoutDocumentPaymentSchedulesLayoutRoute
    }
    '/protected/_layout/delivery-notes/_layout/new': {
      id: '/protected/_layout/delivery-notes/_layout/new'
      path: '/new'
      fullPath: '/protected/delivery-notes/new'
      preLoaderRoute: typeof ProtectedLayoutDeliveryNotesLayoutNewRouteImport
      parentRoute: typeof ProtectedLayoutDeliveryNotesLayoutRoute
    }
    '/protected/_layout/delivery-notes/_layout/$id': {
      id: '/protected/_layout/delivery-notes/_layout/$id'
      path: '/$id'
      fullPath: '/protected/delivery-notes/$id'
      preLoaderRoute: typeof ProtectedLayoutDeliveryNotesLayoutIdRouteImport
      parentRoute: typeof ProtectedLayoutDeliveryNotesLayoutRoute
    }
    '/protected/_layout/commesse/_layout/new': {
      id: '/protected/_layout/commesse/_layout/new'
      path: '/new'
      fullPath: '/protected/commesse/new'
      preLoaderRoute: typeof ProtectedLayoutCommesseLayoutNewRouteImport
      parentRoute: typeof ProtectedLayoutCommesseLayoutRoute
    }
    '/protected/_layout/commesse/_layout/$id': {
      id: '/protected/_layout/commesse/_layout/$id'
      path: '/$id'
      fullPath: '/protected/commesse/$id'
      preLoaderRoute: typeof ProtectedLayoutCommesseLayoutIdRouteImport
      parentRoute: typeof ProtectedLayoutCommesseLayoutRoute
    }
    '/protected/_layout/administration/_layout/new': {
      id: '/protected/_layout/administration/_layout/new'
      path: '/new'
      fullPath: '/protected/administration/new'
      preLoaderRoute: typeof ProtectedLayoutAdministrationLayoutNewRouteImport
      parentRoute: typeof ProtectedLayoutAdministrationLayoutRoute
    }
    '/protected/_layout/administration/_layout/$id': {
      id: '/protected/_layout/administration/_layout/$id'
      path: '/$id'
      fullPath: '/protected/administration/$id'
      preLoaderRoute: typeof ProtectedLayoutAdministrationLayoutIdRouteImport
      parentRoute: typeof ProtectedLayoutAdministrationLayoutRoute
    }
    '/protected/_layout/accounts/_layout/new': {
      id: '/protected/_layout/accounts/_layout/new'
      path: '/new'
      fullPath: '/protected/accounts/new'
      preLoaderRoute: typeof ProtectedLayoutAccountsLayoutNewRouteImport
      parentRoute: typeof ProtectedLayoutAccountsLayoutRoute
    }
    '/protected/_layout/accounts/_layout/$id': {
      id: '/protected/_layout/accounts/_layout/$id'
      path: '/$id'
      fullPath: '/protected/accounts/$id'
      preLoaderRoute: typeof ProtectedLayoutAccountsLayoutIdRouteImport
      parentRoute: typeof ProtectedLayoutAccountsLayoutRoute
    }
    '/protected/_layout/settings/_layout/users/new': {
      id: '/protected/_layout/settings/_layout/users/new'
      path: '/users/new'
      fullPath: '/protected/settings/users/new'
      preLoaderRoute: typeof ProtectedLayoutSettingsLayoutUsersNewRouteImport
      parentRoute: typeof ProtectedLayoutSettingsLayoutRoute
    }
    '/protected/_layout/settings/_layout/users/$id': {
      id: '/protected/_layout/settings/_layout/users/$id'
      path: '/users/$id'
      fullPath: '/protected/settings/users/$id'
      preLoaderRoute: typeof ProtectedLayoutSettingsLayoutUsersIdRouteImport
      parentRoute: typeof ProtectedLayoutSettingsLayoutRoute
    }
    '/protected/_layout/settings/_layout/categories/new': {
      id: '/protected/_layout/settings/_layout/categories/new'
      path: '/categories/new'
      fullPath: '/protected/settings/categories/new'
      preLoaderRoute: typeof ProtectedLayoutSettingsLayoutCategoriesNewRouteImport
      parentRoute: typeof ProtectedLayoutSettingsLayoutRoute
    }
    '/protected/_layout/settings/_layout/categories/$id': {
      id: '/protected/_layout/settings/_layout/categories/$id'
      path: '/categories/$id'
      fullPath: '/protected/settings/categories/$id'
      preLoaderRoute: typeof ProtectedLayoutSettingsLayoutCategoriesIdRouteImport
      parentRoute: typeof ProtectedLayoutSettingsLayoutRoute
    }
    '/protected/_layout/registry/_layout/products/new-service': {
      id: '/protected/_layout/registry/_layout/products/new-service'
      path: '/products/new-service'
      fullPath: '/protected/registry/products/new-service'
      preLoaderRoute: typeof ProtectedLayoutRegistryLayoutProductsNewServiceRouteImport
      parentRoute: typeof ProtectedLayoutRegistryLayoutRoute
    }
    '/protected/_layout/registry/_layout/products/new': {
      id: '/protected/_layout/registry/_layout/products/new'
      path: '/products/new'
      fullPath: '/protected/registry/products/new'
      preLoaderRoute: typeof ProtectedLayoutRegistryLayoutProductsNewRouteImport
      parentRoute: typeof ProtectedLayoutRegistryLayoutRoute
    }
    '/protected/_layout/registry/_layout/products/$id': {
      id: '/protected/_layout/registry/_layout/products/$id'
      path: '/products/$id'
      fullPath: '/protected/registry/products/$id'
      preLoaderRoute: typeof ProtectedLayoutRegistryLayoutProductsIdRouteImport
      parentRoute: typeof ProtectedLayoutRegistryLayoutRoute
    }
    '/protected/_layout/registry/_layout/employees/new': {
      id: '/protected/_layout/registry/_layout/employees/new'
      path: '/employees/new'
      fullPath: '/protected/registry/employees/new'
      preLoaderRoute: typeof ProtectedLayoutRegistryLayoutEmployeesNewRouteImport
      parentRoute: typeof ProtectedLayoutRegistryLayoutRoute
    }
    '/protected/_layout/registry/_layout/employees/$id': {
      id: '/protected/_layout/registry/_layout/employees/$id'
      path: '/employees/$id'
      fullPath: '/protected/registry/employees/$id'
      preLoaderRoute: typeof ProtectedLayoutRegistryLayoutEmployeesIdRouteImport
      parentRoute: typeof ProtectedLayoutRegistryLayoutRoute
    }
    '/protected/_layout/registry/_layout/counterparts/new': {
      id: '/protected/_layout/registry/_layout/counterparts/new'
      path: '/counterparts/new'
      fullPath: '/protected/registry/counterparts/new'
      preLoaderRoute: typeof ProtectedLayoutRegistryLayoutCounterpartsNewRouteImport
      parentRoute: typeof ProtectedLayoutRegistryLayoutRoute
    }
    '/protected/_layout/registry/_layout/counterparts/$id': {
      id: '/protected/_layout/registry/_layout/counterparts/$id'
      path: '/counterparts/$id'
      fullPath: '/protected/registry/counterparts/$id'
      preLoaderRoute: typeof ProtectedLayoutRegistryLayoutCounterpartsIdRouteImport
      parentRoute: typeof ProtectedLayoutRegistryLayoutRoute
    }
    '/protected/_layout/payments/_layout/documents/$id': {
      id: '/protected/_layout/payments/_layout/documents/$id'
      path: '/documents/$id'
      fullPath: '/protected/payments/documents/$id'
      preLoaderRoute: typeof ProtectedLayoutPaymentsLayoutDocumentsIdRouteImport
      parentRoute: typeof ProtectedLayoutPaymentsLayoutRoute
    }
    '/protected/_layout/machine-checks/_layout/checks/$id': {
      id: '/protected/_layout/machine-checks/_layout/checks/$id'
      path: '/checks/$id'
      fullPath: '/protected/machine-checks/checks/$id'
      preLoaderRoute: typeof ProtectedLayoutMachineChecksLayoutChecksIdRouteImport
      parentRoute: typeof ProtectedLayoutMachineChecksLayoutRoute
    }
    '/protected/_layout/forecast/_layout/recurrences/new': {
      id: '/protected/_layout/forecast/_layout/recurrences/new'
      path: '/recurrences/new'
      fullPath: '/protected/forecast/recurrences/new'
      preLoaderRoute: typeof ProtectedLayoutForecastLayoutRecurrencesNewRouteImport
      parentRoute: typeof ProtectedLayoutForecastLayoutRoute
    }
    '/protected/_layout/forecast/_layout/recurrences/$id': {
      id: '/protected/_layout/forecast/_layout/recurrences/$id'
      path: '/recurrences/$id'
      fullPath: '/protected/forecast/recurrences/$id'
      preLoaderRoute: typeof ProtectedLayoutForecastLayoutRecurrencesIdRouteImport
      parentRoute: typeof ProtectedLayoutForecastLayoutRoute
    }
    '/protected/_layout/forecast/_layout/planning/new': {
      id: '/protected/_layout/forecast/_layout/planning/new'
      path: '/planning/new'
      fullPath: '/protected/forecast/planning/new'
      preLoaderRoute: typeof ProtectedLayoutForecastLayoutPlanningNewRouteImport
      parentRoute: typeof ProtectedLayoutForecastLayoutRoute
    }
    '/protected/_layout/forecast/_layout/planning/$id': {
      id: '/protected/_layout/forecast/_layout/planning/$id'
      path: '/planning/$id'
      fullPath: '/protected/forecast/planning/$id'
      preLoaderRoute: typeof ProtectedLayoutForecastLayoutPlanningIdRouteImport
      parentRoute: typeof ProtectedLayoutForecastLayoutRoute
    }
    '/protected/_layout/forecast/_layout/forecast/new': {
      id: '/protected/_layout/forecast/_layout/forecast/new'
      path: '/forecast/new'
      fullPath: '/protected/forecast/forecast/new'
      preLoaderRoute: typeof ProtectedLayoutForecastLayoutForecastNewRouteImport
      parentRoute: typeof ProtectedLayoutForecastLayoutRoute
    }
    '/protected/_layout/forecast/_layout/forecast/$id': {
      id: '/protected/_layout/forecast/_layout/forecast/$id'
      path: '/forecast/$id'
      fullPath: '/protected/forecast/forecast/$id'
      preLoaderRoute: typeof ProtectedLayoutForecastLayoutForecastIdRouteImport
      parentRoute: typeof ProtectedLayoutForecastLayoutRoute
    }
    '/protected/_layout/forecast/_layout/document/$id': {
      id: '/protected/_layout/forecast/_layout/document/$id'
      path: '/document/$id'
      fullPath: '/protected/forecast/document/$id'
      preLoaderRoute: typeof ProtectedLayoutForecastLayoutDocumentIdRouteImport
      parentRoute: typeof ProtectedLayoutForecastLayoutRoute
    }
    '/protected/_layout/forecast/_layout/cash-movement/$id': {
      id: '/protected/_layout/forecast/_layout/cash-movement/$id'
      path: '/cash-movement/$id'
      fullPath: '/protected/forecast/cash-movement/$id'
      preLoaderRoute: typeof ProtectedLayoutForecastLayoutCashMovementIdRouteImport
      parentRoute: typeof ProtectedLayoutForecastLayoutRoute
    }
    '/protected/_layout/documents/_layout/debts/new': {
      id: '/protected/_layout/documents/_layout/debts/new'
      path: '/debts/new'
      fullPath: '/protected/documents/debts/new'
      preLoaderRoute: typeof ProtectedLayoutDocumentsLayoutDebtsNewRouteImport
      parentRoute: typeof ProtectedLayoutDocumentsLayoutRoute
    }
    '/protected/_layout/documents/_layout/debts/$id': {
      id: '/protected/_layout/documents/_layout/debts/$id'
      path: '/debts/$id'
      fullPath: '/protected/documents/debts/$id'
      preLoaderRoute: typeof ProtectedLayoutDocumentsLayoutDebtsIdRouteImport
      parentRoute: typeof ProtectedLayoutDocumentsLayoutRoute
    }
    '/protected/_layout/accounts/_layout/movements/new': {
      id: '/protected/_layout/accounts/_layout/movements/new'
      path: '/movements/new'
      fullPath: '/protected/accounts/movements/new'
      preLoaderRoute: typeof ProtectedLayoutAccountsLayoutMovementsNewRouteImport
      parentRoute: typeof ProtectedLayoutAccountsLayoutRoute
    }
    '/protected/_layout/accounts/_layout/movements/$id': {
      id: '/protected/_layout/accounts/_layout/movements/$id'
      path: '/movements/$id'
      fullPath: '/protected/accounts/movements/$id'
      preLoaderRoute: typeof ProtectedLayoutAccountsLayoutMovementsIdRouteImport
      parentRoute: typeof ProtectedLayoutAccountsLayoutRoute
    }
    '/protected/_layout/settings/_layout/categories/$id/keywords': {
      id: '/protected/_layout/settings/_layout/categories/$id/keywords'
      path: '/keywords'
      fullPath: '/protected/settings/categories/$id/keywords'
      preLoaderRoute: typeof ProtectedLayoutSettingsLayoutCategoriesIdKeywordsRouteImport
      parentRoute: typeof ProtectedLayoutSettingsLayoutCategoriesIdRoute
    }
  }
}

interface ProtectedLayoutHelpCategoryRouteChildren {
  ProtectedLayoutHelpCategoryArticleRoute: typeof ProtectedLayoutHelpCategoryArticleRoute
  ProtectedLayoutHelpCategoryIndexRoute: typeof ProtectedLayoutHelpCategoryIndexRoute
}

const ProtectedLayoutHelpCategoryRouteChildren: ProtectedLayoutHelpCategoryRouteChildren =
  {
    ProtectedLayoutHelpCategoryArticleRoute:
      ProtectedLayoutHelpCategoryArticleRoute,
    ProtectedLayoutHelpCategoryIndexRoute:
      ProtectedLayoutHelpCategoryIndexRoute,
  }

const ProtectedLayoutHelpCategoryRouteWithChildren =
  ProtectedLayoutHelpCategoryRoute._addFileChildren(
    ProtectedLayoutHelpCategoryRouteChildren,
  )

interface ProtectedLayoutHelpRouteChildren {
  ProtectedLayoutHelpCategoryRoute: typeof ProtectedLayoutHelpCategoryRouteWithChildren
  ProtectedLayoutHelpFaqRoute: typeof ProtectedLayoutHelpFaqRoute
  ProtectedLayoutHelpIndexRoute: typeof ProtectedLayoutHelpIndexRoute
}

const ProtectedLayoutHelpRouteChildren: ProtectedLayoutHelpRouteChildren = {
  ProtectedLayoutHelpCategoryRoute:
    ProtectedLayoutHelpCategoryRouteWithChildren,
  ProtectedLayoutHelpFaqRoute: ProtectedLayoutHelpFaqRoute,
  ProtectedLayoutHelpIndexRoute: ProtectedLayoutHelpIndexRoute,
}

const ProtectedLayoutHelpRouteWithChildren =
  ProtectedLayoutHelpRoute._addFileChildren(ProtectedLayoutHelpRouteChildren)

interface ProtectedLayoutAccountsLayoutRouteChildren {
  ProtectedLayoutAccountsLayoutIdRoute: typeof ProtectedLayoutAccountsLayoutIdRoute
  ProtectedLayoutAccountsLayoutNewRoute: typeof ProtectedLayoutAccountsLayoutNewRoute
  ProtectedLayoutAccountsLayoutIndexRoute: typeof ProtectedLayoutAccountsLayoutIndexRoute
  ProtectedLayoutAccountsLayoutMovementsIdRoute: typeof ProtectedLayoutAccountsLayoutMovementsIdRoute
  ProtectedLayoutAccountsLayoutMovementsNewRoute: typeof ProtectedLayoutAccountsLayoutMovementsNewRoute
}

const ProtectedLayoutAccountsLayoutRouteChildren: ProtectedLayoutAccountsLayoutRouteChildren =
  {
    ProtectedLayoutAccountsLayoutIdRoute: ProtectedLayoutAccountsLayoutIdRoute,
    ProtectedLayoutAccountsLayoutNewRoute:
      ProtectedLayoutAccountsLayoutNewRoute,
    ProtectedLayoutAccountsLayoutIndexRoute:
      ProtectedLayoutAccountsLayoutIndexRoute,
    ProtectedLayoutAccountsLayoutMovementsIdRoute:
      ProtectedLayoutAccountsLayoutMovementsIdRoute,
    ProtectedLayoutAccountsLayoutMovementsNewRoute:
      ProtectedLayoutAccountsLayoutMovementsNewRoute,
  }

const ProtectedLayoutAccountsLayoutRouteWithChildren =
  ProtectedLayoutAccountsLayoutRoute._addFileChildren(
    ProtectedLayoutAccountsLayoutRouteChildren,
  )

interface ProtectedLayoutAccountsRouteChildren {
  ProtectedLayoutAccountsLayoutRoute: typeof ProtectedLayoutAccountsLayoutRouteWithChildren
}

const ProtectedLayoutAccountsRouteChildren: ProtectedLayoutAccountsRouteChildren =
  {
    ProtectedLayoutAccountsLayoutRoute:
      ProtectedLayoutAccountsLayoutRouteWithChildren,
  }

const ProtectedLayoutAccountsRouteWithChildren =
  ProtectedLayoutAccountsRoute._addFileChildren(
    ProtectedLayoutAccountsRouteChildren,
  )

interface ProtectedLayoutAdministrationLayoutRouteChildren {
  ProtectedLayoutAdministrationLayoutIdRoute: typeof ProtectedLayoutAdministrationLayoutIdRoute
  ProtectedLayoutAdministrationLayoutNewRoute: typeof ProtectedLayoutAdministrationLayoutNewRoute
  ProtectedLayoutAdministrationLayoutIndexRoute: typeof ProtectedLayoutAdministrationLayoutIndexRoute
}

const ProtectedLayoutAdministrationLayoutRouteChildren: ProtectedLayoutAdministrationLayoutRouteChildren =
  {
    ProtectedLayoutAdministrationLayoutIdRoute:
      ProtectedLayoutAdministrationLayoutIdRoute,
    ProtectedLayoutAdministrationLayoutNewRoute:
      ProtectedLayoutAdministrationLayoutNewRoute,
    ProtectedLayoutAdministrationLayoutIndexRoute:
      ProtectedLayoutAdministrationLayoutIndexRoute,
  }

const ProtectedLayoutAdministrationLayoutRouteWithChildren =
  ProtectedLayoutAdministrationLayoutRoute._addFileChildren(
    ProtectedLayoutAdministrationLayoutRouteChildren,
  )

interface ProtectedLayoutAdministrationRouteChildren {
  ProtectedLayoutAdministrationLayoutRoute: typeof ProtectedLayoutAdministrationLayoutRouteWithChildren
}

const ProtectedLayoutAdministrationRouteChildren: ProtectedLayoutAdministrationRouteChildren =
  {
    ProtectedLayoutAdministrationLayoutRoute:
      ProtectedLayoutAdministrationLayoutRouteWithChildren,
  }

const ProtectedLayoutAdministrationRouteWithChildren =
  ProtectedLayoutAdministrationRoute._addFileChildren(
    ProtectedLayoutAdministrationRouteChildren,
  )

interface ProtectedLayoutCommesseLayoutRouteChildren {
  ProtectedLayoutCommesseLayoutIdRoute: typeof ProtectedLayoutCommesseLayoutIdRoute
  ProtectedLayoutCommesseLayoutNewRoute: typeof ProtectedLayoutCommesseLayoutNewRoute
  ProtectedLayoutCommesseLayoutIndexRoute: typeof ProtectedLayoutCommesseLayoutIndexRoute
}

const ProtectedLayoutCommesseLayoutRouteChildren: ProtectedLayoutCommesseLayoutRouteChildren =
  {
    ProtectedLayoutCommesseLayoutIdRoute: ProtectedLayoutCommesseLayoutIdRoute,
    ProtectedLayoutCommesseLayoutNewRoute:
      ProtectedLayoutCommesseLayoutNewRoute,
    ProtectedLayoutCommesseLayoutIndexRoute:
      ProtectedLayoutCommesseLayoutIndexRoute,
  }

const ProtectedLayoutCommesseLayoutRouteWithChildren =
  ProtectedLayoutCommesseLayoutRoute._addFileChildren(
    ProtectedLayoutCommesseLayoutRouteChildren,
  )

interface ProtectedLayoutCommesseRouteChildren {
  ProtectedLayoutCommesseLayoutRoute: typeof ProtectedLayoutCommesseLayoutRouteWithChildren
}

const ProtectedLayoutCommesseRouteChildren: ProtectedLayoutCommesseRouteChildren =
  {
    ProtectedLayoutCommesseLayoutRoute:
      ProtectedLayoutCommesseLayoutRouteWithChildren,
  }

const ProtectedLayoutCommesseRouteWithChildren =
  ProtectedLayoutCommesseRoute._addFileChildren(
    ProtectedLayoutCommesseRouteChildren,
  )

interface ProtectedLayoutDeliveryNotesLayoutRouteChildren {
  ProtectedLayoutDeliveryNotesLayoutIdRoute: typeof ProtectedLayoutDeliveryNotesLayoutIdRoute
  ProtectedLayoutDeliveryNotesLayoutNewRoute: typeof ProtectedLayoutDeliveryNotesLayoutNewRoute
  ProtectedLayoutDeliveryNotesLayoutIndexRoute: typeof ProtectedLayoutDeliveryNotesLayoutIndexRoute
}

const ProtectedLayoutDeliveryNotesLayoutRouteChildren: ProtectedLayoutDeliveryNotesLayoutRouteChildren =
  {
    ProtectedLayoutDeliveryNotesLayoutIdRoute:
      ProtectedLayoutDeliveryNotesLayoutIdRoute,
    ProtectedLayoutDeliveryNotesLayoutNewRoute:
      ProtectedLayoutDeliveryNotesLayoutNewRoute,
    ProtectedLayoutDeliveryNotesLayoutIndexRoute:
      ProtectedLayoutDeliveryNotesLayoutIndexRoute,
  }

const ProtectedLayoutDeliveryNotesLayoutRouteWithChildren =
  ProtectedLayoutDeliveryNotesLayoutRoute._addFileChildren(
    ProtectedLayoutDeliveryNotesLayoutRouteChildren,
  )

interface ProtectedLayoutDeliveryNotesRouteChildren {
  ProtectedLayoutDeliveryNotesLayoutRoute: typeof ProtectedLayoutDeliveryNotesLayoutRouteWithChildren
}

const ProtectedLayoutDeliveryNotesRouteChildren: ProtectedLayoutDeliveryNotesRouteChildren =
  {
    ProtectedLayoutDeliveryNotesLayoutRoute:
      ProtectedLayoutDeliveryNotesLayoutRouteWithChildren,
  }

const ProtectedLayoutDeliveryNotesRouteWithChildren =
  ProtectedLayoutDeliveryNotesRoute._addFileChildren(
    ProtectedLayoutDeliveryNotesRouteChildren,
  )

interface ProtectedLayoutDistinteRibaLayoutRouteChildren {
  ProtectedLayoutDistinteRibaLayoutIndexRoute: typeof ProtectedLayoutDistinteRibaLayoutIndexRoute
}

const ProtectedLayoutDistinteRibaLayoutRouteChildren: ProtectedLayoutDistinteRibaLayoutRouteChildren =
  {
    ProtectedLayoutDistinteRibaLayoutIndexRoute:
      ProtectedLayoutDistinteRibaLayoutIndexRoute,
  }

const ProtectedLayoutDistinteRibaLayoutRouteWithChildren =
  ProtectedLayoutDistinteRibaLayoutRoute._addFileChildren(
    ProtectedLayoutDistinteRibaLayoutRouteChildren,
  )

interface ProtectedLayoutDistinteRibaRouteChildren {
  ProtectedLayoutDistinteRibaLayoutRoute: typeof ProtectedLayoutDistinteRibaLayoutRouteWithChildren
}

const ProtectedLayoutDistinteRibaRouteChildren: ProtectedLayoutDistinteRibaRouteChildren =
  {
    ProtectedLayoutDistinteRibaLayoutRoute:
      ProtectedLayoutDistinteRibaLayoutRouteWithChildren,
  }

const ProtectedLayoutDistinteRibaRouteWithChildren =
  ProtectedLayoutDistinteRibaRoute._addFileChildren(
    ProtectedLayoutDistinteRibaRouteChildren,
  )

interface ProtectedLayoutDocumentPaymentSchedulesLayoutRouteChildren {
  ProtectedLayoutDocumentPaymentSchedulesLayoutIdRoute: typeof ProtectedLayoutDocumentPaymentSchedulesLayoutIdRoute
  ProtectedLayoutDocumentPaymentSchedulesLayoutNewRoute: typeof ProtectedLayoutDocumentPaymentSchedulesLayoutNewRoute
  ProtectedLayoutDocumentPaymentSchedulesLayoutIndexRoute: typeof ProtectedLayoutDocumentPaymentSchedulesLayoutIndexRoute
}

const ProtectedLayoutDocumentPaymentSchedulesLayoutRouteChildren: ProtectedLayoutDocumentPaymentSchedulesLayoutRouteChildren =
  {
    ProtectedLayoutDocumentPaymentSchedulesLayoutIdRoute:
      ProtectedLayoutDocumentPaymentSchedulesLayoutIdRoute,
    ProtectedLayoutDocumentPaymentSchedulesLayoutNewRoute:
      ProtectedLayoutDocumentPaymentSchedulesLayoutNewRoute,
    ProtectedLayoutDocumentPaymentSchedulesLayoutIndexRoute:
      ProtectedLayoutDocumentPaymentSchedulesLayoutIndexRoute,
  }

const ProtectedLayoutDocumentPaymentSchedulesLayoutRouteWithChildren =
  ProtectedLayoutDocumentPaymentSchedulesLayoutRoute._addFileChildren(
    ProtectedLayoutDocumentPaymentSchedulesLayoutRouteChildren,
  )

interface ProtectedLayoutDocumentPaymentSchedulesRouteChildren {
  ProtectedLayoutDocumentPaymentSchedulesLayoutRoute: typeof ProtectedLayoutDocumentPaymentSchedulesLayoutRouteWithChildren
}

const ProtectedLayoutDocumentPaymentSchedulesRouteChildren: ProtectedLayoutDocumentPaymentSchedulesRouteChildren =
  {
    ProtectedLayoutDocumentPaymentSchedulesLayoutRoute:
      ProtectedLayoutDocumentPaymentSchedulesLayoutRouteWithChildren,
  }

const ProtectedLayoutDocumentPaymentSchedulesRouteWithChildren =
  ProtectedLayoutDocumentPaymentSchedulesRoute._addFileChildren(
    ProtectedLayoutDocumentPaymentSchedulesRouteChildren,
  )

interface ProtectedLayoutDocumentsLayoutRouteChildren {
  ProtectedLayoutDocumentsLayoutIdRoute: typeof ProtectedLayoutDocumentsLayoutIdRoute
  ProtectedLayoutDocumentsLayoutNewRoute: typeof ProtectedLayoutDocumentsLayoutNewRoute
  ProtectedLayoutDocumentsLayoutIndexRoute: typeof ProtectedLayoutDocumentsLayoutIndexRoute
  ProtectedLayoutDocumentsLayoutDebtsIdRoute: typeof ProtectedLayoutDocumentsLayoutDebtsIdRoute
  ProtectedLayoutDocumentsLayoutDebtsNewRoute: typeof ProtectedLayoutDocumentsLayoutDebtsNewRoute
}

const ProtectedLayoutDocumentsLayoutRouteChildren: ProtectedLayoutDocumentsLayoutRouteChildren =
  {
    ProtectedLayoutDocumentsLayoutIdRoute:
      ProtectedLayoutDocumentsLayoutIdRoute,
    ProtectedLayoutDocumentsLayoutNewRoute:
      ProtectedLayoutDocumentsLayoutNewRoute,
    ProtectedLayoutDocumentsLayoutIndexRoute:
      ProtectedLayoutDocumentsLayoutIndexRoute,
    ProtectedLayoutDocumentsLayoutDebtsIdRoute:
      ProtectedLayoutDocumentsLayoutDebtsIdRoute,
    ProtectedLayoutDocumentsLayoutDebtsNewRoute:
      ProtectedLayoutDocumentsLayoutDebtsNewRoute,
  }

const ProtectedLayoutDocumentsLayoutRouteWithChildren =
  ProtectedLayoutDocumentsLayoutRoute._addFileChildren(
    ProtectedLayoutDocumentsLayoutRouteChildren,
  )

interface ProtectedLayoutDocumentsRouteChildren {
  ProtectedLayoutDocumentsLayoutRoute: typeof ProtectedLayoutDocumentsLayoutRouteWithChildren
}

const ProtectedLayoutDocumentsRouteChildren: ProtectedLayoutDocumentsRouteChildren =
  {
    ProtectedLayoutDocumentsLayoutRoute:
      ProtectedLayoutDocumentsLayoutRouteWithChildren,
  }

const ProtectedLayoutDocumentsRouteWithChildren =
  ProtectedLayoutDocumentsRoute._addFileChildren(
    ProtectedLayoutDocumentsRouteChildren,
  )

interface ProtectedLayoutForecastLayoutRouteChildren {
  ProtectedLayoutForecastLayoutIndexRoute: typeof ProtectedLayoutForecastLayoutIndexRoute
  ProtectedLayoutForecastLayoutCashMovementIdRoute: typeof ProtectedLayoutForecastLayoutCashMovementIdRoute
  ProtectedLayoutForecastLayoutDocumentIdRoute: typeof ProtectedLayoutForecastLayoutDocumentIdRoute
  ProtectedLayoutForecastLayoutForecastIdRoute: typeof ProtectedLayoutForecastLayoutForecastIdRoute
  ProtectedLayoutForecastLayoutForecastNewRoute: typeof ProtectedLayoutForecastLayoutForecastNewRoute
  ProtectedLayoutForecastLayoutPlanningIdRoute: typeof ProtectedLayoutForecastLayoutPlanningIdRoute
  ProtectedLayoutForecastLayoutPlanningNewRoute: typeof ProtectedLayoutForecastLayoutPlanningNewRoute
  ProtectedLayoutForecastLayoutRecurrencesIdRoute: typeof ProtectedLayoutForecastLayoutRecurrencesIdRoute
  ProtectedLayoutForecastLayoutRecurrencesNewRoute: typeof ProtectedLayoutForecastLayoutRecurrencesNewRoute
}

const ProtectedLayoutForecastLayoutRouteChildren: ProtectedLayoutForecastLayoutRouteChildren =
  {
    ProtectedLayoutForecastLayoutIndexRoute:
      ProtectedLayoutForecastLayoutIndexRoute,
    ProtectedLayoutForecastLayoutCashMovementIdRoute:
      ProtectedLayoutForecastLayoutCashMovementIdRoute,
    ProtectedLayoutForecastLayoutDocumentIdRoute:
      ProtectedLayoutForecastLayoutDocumentIdRoute,
    ProtectedLayoutForecastLayoutForecastIdRoute:
      ProtectedLayoutForecastLayoutForecastIdRoute,
    ProtectedLayoutForecastLayoutForecastNewRoute:
      ProtectedLayoutForecastLayoutForecastNewRoute,
    ProtectedLayoutForecastLayoutPlanningIdRoute:
      ProtectedLayoutForecastLayoutPlanningIdRoute,
    ProtectedLayoutForecastLayoutPlanningNewRoute:
      ProtectedLayoutForecastLayoutPlanningNewRoute,
    ProtectedLayoutForecastLayoutRecurrencesIdRoute:
      ProtectedLayoutForecastLayoutRecurrencesIdRoute,
    ProtectedLayoutForecastLayoutRecurrencesNewRoute:
      ProtectedLayoutForecastLayoutRecurrencesNewRoute,
  }

const ProtectedLayoutForecastLayoutRouteWithChildren =
  ProtectedLayoutForecastLayoutRoute._addFileChildren(
    ProtectedLayoutForecastLayoutRouteChildren,
  )

interface ProtectedLayoutForecastRouteChildren {
  ProtectedLayoutForecastLayoutRoute: typeof ProtectedLayoutForecastLayoutRouteWithChildren
}

const ProtectedLayoutForecastRouteChildren: ProtectedLayoutForecastRouteChildren =
  {
    ProtectedLayoutForecastLayoutRoute:
      ProtectedLayoutForecastLayoutRouteWithChildren,
  }

const ProtectedLayoutForecastRouteWithChildren =
  ProtectedLayoutForecastRoute._addFileChildren(
    ProtectedLayoutForecastRouteChildren,
  )

interface ProtectedLayoutHotelLayoutRouteChildren {
  ProtectedLayoutHotelLayoutIdRoute: typeof ProtectedLayoutHotelLayoutIdRoute
  ProtectedLayoutHotelLayoutNewRoute: typeof ProtectedLayoutHotelLayoutNewRoute
  ProtectedLayoutHotelLayoutIndexRoute: typeof ProtectedLayoutHotelLayoutIndexRoute
}

const ProtectedLayoutHotelLayoutRouteChildren: ProtectedLayoutHotelLayoutRouteChildren =
  {
    ProtectedLayoutHotelLayoutIdRoute: ProtectedLayoutHotelLayoutIdRoute,
    ProtectedLayoutHotelLayoutNewRoute: ProtectedLayoutHotelLayoutNewRoute,
    ProtectedLayoutHotelLayoutIndexRoute: ProtectedLayoutHotelLayoutIndexRoute,
  }

const ProtectedLayoutHotelLayoutRouteWithChildren =
  ProtectedLayoutHotelLayoutRoute._addFileChildren(
    ProtectedLayoutHotelLayoutRouteChildren,
  )

interface ProtectedLayoutHotelRouteChildren {
  ProtectedLayoutHotelLayoutRoute: typeof ProtectedLayoutHotelLayoutRouteWithChildren
}

const ProtectedLayoutHotelRouteChildren: ProtectedLayoutHotelRouteChildren = {
  ProtectedLayoutHotelLayoutRoute: ProtectedLayoutHotelLayoutRouteWithChildren,
}

const ProtectedLayoutHotelRouteWithChildren =
  ProtectedLayoutHotelRoute._addFileChildren(ProtectedLayoutHotelRouteChildren)

interface ProtectedLayoutInventoryLayoutRouteChildren {
  ProtectedLayoutInventoryLayoutIdRoute: typeof ProtectedLayoutInventoryLayoutIdRoute
  ProtectedLayoutInventoryLayoutNewRoute: typeof ProtectedLayoutInventoryLayoutNewRoute
  ProtectedLayoutInventoryLayoutIndexRoute: typeof ProtectedLayoutInventoryLayoutIndexRoute
}

const ProtectedLayoutInventoryLayoutRouteChildren: ProtectedLayoutInventoryLayoutRouteChildren =
  {
    ProtectedLayoutInventoryLayoutIdRoute:
      ProtectedLayoutInventoryLayoutIdRoute,
    ProtectedLayoutInventoryLayoutNewRoute:
      ProtectedLayoutInventoryLayoutNewRoute,
    ProtectedLayoutInventoryLayoutIndexRoute:
      ProtectedLayoutInventoryLayoutIndexRoute,
  }

const ProtectedLayoutInventoryLayoutRouteWithChildren =
  ProtectedLayoutInventoryLayoutRoute._addFileChildren(
    ProtectedLayoutInventoryLayoutRouteChildren,
  )

interface ProtectedLayoutInventoryRouteChildren {
  ProtectedLayoutInventoryLayoutRoute: typeof ProtectedLayoutInventoryLayoutRouteWithChildren
}

const ProtectedLayoutInventoryRouteChildren: ProtectedLayoutInventoryRouteChildren =
  {
    ProtectedLayoutInventoryLayoutRoute:
      ProtectedLayoutInventoryLayoutRouteWithChildren,
  }

const ProtectedLayoutInventoryRouteWithChildren =
  ProtectedLayoutInventoryRoute._addFileChildren(
    ProtectedLayoutInventoryRouteChildren,
  )

interface ProtectedLayoutInvoicesLayoutRouteChildren {
  ProtectedLayoutInvoicesLayoutIdRoute: typeof ProtectedLayoutInvoicesLayoutIdRoute
  ProtectedLayoutInvoicesLayoutNewRoute: typeof ProtectedLayoutInvoicesLayoutNewRoute
  ProtectedLayoutInvoicesLayoutIndexRoute: typeof ProtectedLayoutInvoicesLayoutIndexRoute
}

const ProtectedLayoutInvoicesLayoutRouteChildren: ProtectedLayoutInvoicesLayoutRouteChildren =
  {
    ProtectedLayoutInvoicesLayoutIdRoute: ProtectedLayoutInvoicesLayoutIdRoute,
    ProtectedLayoutInvoicesLayoutNewRoute:
      ProtectedLayoutInvoicesLayoutNewRoute,
    ProtectedLayoutInvoicesLayoutIndexRoute:
      ProtectedLayoutInvoicesLayoutIndexRoute,
  }

const ProtectedLayoutInvoicesLayoutRouteWithChildren =
  ProtectedLayoutInvoicesLayoutRoute._addFileChildren(
    ProtectedLayoutInvoicesLayoutRouteChildren,
  )

interface ProtectedLayoutInvoicesRouteChildren {
  ProtectedLayoutInvoicesLayoutRoute: typeof ProtectedLayoutInvoicesLayoutRouteWithChildren
}

const ProtectedLayoutInvoicesRouteChildren: ProtectedLayoutInvoicesRouteChildren =
  {
    ProtectedLayoutInvoicesLayoutRoute:
      ProtectedLayoutInvoicesLayoutRouteWithChildren,
  }

const ProtectedLayoutInvoicesRouteWithChildren =
  ProtectedLayoutInvoicesRoute._addFileChildren(
    ProtectedLayoutInvoicesRouteChildren,
  )

interface ProtectedLayoutMachineChecksLayoutRouteChildren {
  ProtectedLayoutMachineChecksLayoutIndexRoute: typeof ProtectedLayoutMachineChecksLayoutIndexRoute
  ProtectedLayoutMachineChecksLayoutChecksIdRoute: typeof ProtectedLayoutMachineChecksLayoutChecksIdRoute
}

const ProtectedLayoutMachineChecksLayoutRouteChildren: ProtectedLayoutMachineChecksLayoutRouteChildren =
  {
    ProtectedLayoutMachineChecksLayoutIndexRoute:
      ProtectedLayoutMachineChecksLayoutIndexRoute,
    ProtectedLayoutMachineChecksLayoutChecksIdRoute:
      ProtectedLayoutMachineChecksLayoutChecksIdRoute,
  }

const ProtectedLayoutMachineChecksLayoutRouteWithChildren =
  ProtectedLayoutMachineChecksLayoutRoute._addFileChildren(
    ProtectedLayoutMachineChecksLayoutRouteChildren,
  )

interface ProtectedLayoutMachineChecksRouteChildren {
  ProtectedLayoutMachineChecksLayoutRoute: typeof ProtectedLayoutMachineChecksLayoutRouteWithChildren
}

const ProtectedLayoutMachineChecksRouteChildren: ProtectedLayoutMachineChecksRouteChildren =
  {
    ProtectedLayoutMachineChecksLayoutRoute:
      ProtectedLayoutMachineChecksLayoutRouteWithChildren,
  }

const ProtectedLayoutMachineChecksRouteWithChildren =
  ProtectedLayoutMachineChecksRoute._addFileChildren(
    ProtectedLayoutMachineChecksRouteChildren,
  )

interface ProtectedLayoutMachinesLayoutRouteChildren {
  ProtectedLayoutMachinesLayoutIdRoute: typeof ProtectedLayoutMachinesLayoutIdRoute
  ProtectedLayoutMachinesLayoutNewRoute: typeof ProtectedLayoutMachinesLayoutNewRoute
  ProtectedLayoutMachinesLayoutIndexRoute: typeof ProtectedLayoutMachinesLayoutIndexRoute
}

const ProtectedLayoutMachinesLayoutRouteChildren: ProtectedLayoutMachinesLayoutRouteChildren =
  {
    ProtectedLayoutMachinesLayoutIdRoute: ProtectedLayoutMachinesLayoutIdRoute,
    ProtectedLayoutMachinesLayoutNewRoute:
      ProtectedLayoutMachinesLayoutNewRoute,
    ProtectedLayoutMachinesLayoutIndexRoute:
      ProtectedLayoutMachinesLayoutIndexRoute,
  }

const ProtectedLayoutMachinesLayoutRouteWithChildren =
  ProtectedLayoutMachinesLayoutRoute._addFileChildren(
    ProtectedLayoutMachinesLayoutRouteChildren,
  )

interface ProtectedLayoutMachinesRouteChildren {
  ProtectedLayoutMachinesLayoutRoute: typeof ProtectedLayoutMachinesLayoutRouteWithChildren
}

const ProtectedLayoutMachinesRouteChildren: ProtectedLayoutMachinesRouteChildren =
  {
    ProtectedLayoutMachinesLayoutRoute:
      ProtectedLayoutMachinesLayoutRouteWithChildren,
  }

const ProtectedLayoutMachinesRouteWithChildren =
  ProtectedLayoutMachinesRoute._addFileChildren(
    ProtectedLayoutMachinesRouteChildren,
  )

interface ProtectedLayoutOrdersLayoutRouteChildren {
  ProtectedLayoutOrdersLayoutIdRoute: typeof ProtectedLayoutOrdersLayoutIdRoute
  ProtectedLayoutOrdersLayoutNewRoute: typeof ProtectedLayoutOrdersLayoutNewRoute
  ProtectedLayoutOrdersLayoutIndexRoute: typeof ProtectedLayoutOrdersLayoutIndexRoute
}

const ProtectedLayoutOrdersLayoutRouteChildren: ProtectedLayoutOrdersLayoutRouteChildren =
  {
    ProtectedLayoutOrdersLayoutIdRoute: ProtectedLayoutOrdersLayoutIdRoute,
    ProtectedLayoutOrdersLayoutNewRoute: ProtectedLayoutOrdersLayoutNewRoute,
    ProtectedLayoutOrdersLayoutIndexRoute:
      ProtectedLayoutOrdersLayoutIndexRoute,
  }

const ProtectedLayoutOrdersLayoutRouteWithChildren =
  ProtectedLayoutOrdersLayoutRoute._addFileChildren(
    ProtectedLayoutOrdersLayoutRouteChildren,
  )

interface ProtectedLayoutOrdersRouteChildren {
  ProtectedLayoutOrdersLayoutRoute: typeof ProtectedLayoutOrdersLayoutRouteWithChildren
}

const ProtectedLayoutOrdersRouteChildren: ProtectedLayoutOrdersRouteChildren = {
  ProtectedLayoutOrdersLayoutRoute:
    ProtectedLayoutOrdersLayoutRouteWithChildren,
}

const ProtectedLayoutOrdersRouteWithChildren =
  ProtectedLayoutOrdersRoute._addFileChildren(
    ProtectedLayoutOrdersRouteChildren,
  )

interface ProtectedLayoutPaymentsLayoutRouteChildren {
  ProtectedLayoutPaymentsLayoutIndexRoute: typeof ProtectedLayoutPaymentsLayoutIndexRoute
  ProtectedLayoutPaymentsLayoutDocumentsIdRoute: typeof ProtectedLayoutPaymentsLayoutDocumentsIdRoute
}

const ProtectedLayoutPaymentsLayoutRouteChildren: ProtectedLayoutPaymentsLayoutRouteChildren =
  {
    ProtectedLayoutPaymentsLayoutIndexRoute:
      ProtectedLayoutPaymentsLayoutIndexRoute,
    ProtectedLayoutPaymentsLayoutDocumentsIdRoute:
      ProtectedLayoutPaymentsLayoutDocumentsIdRoute,
  }

const ProtectedLayoutPaymentsLayoutRouteWithChildren =
  ProtectedLayoutPaymentsLayoutRoute._addFileChildren(
    ProtectedLayoutPaymentsLayoutRouteChildren,
  )

interface ProtectedLayoutPaymentsRouteChildren {
  ProtectedLayoutPaymentsLayoutRoute: typeof ProtectedLayoutPaymentsLayoutRouteWithChildren
}

const ProtectedLayoutPaymentsRouteChildren: ProtectedLayoutPaymentsRouteChildren =
  {
    ProtectedLayoutPaymentsLayoutRoute:
      ProtectedLayoutPaymentsLayoutRouteWithChildren,
  }

const ProtectedLayoutPaymentsRouteWithChildren =
  ProtectedLayoutPaymentsRoute._addFileChildren(
    ProtectedLayoutPaymentsRouteChildren,
  )

interface ProtectedLayoutPriceListsLayoutRouteChildren {
  ProtectedLayoutPriceListsLayoutIdRoute: typeof ProtectedLayoutPriceListsLayoutIdRoute
  ProtectedLayoutPriceListsLayoutNewRoute: typeof ProtectedLayoutPriceListsLayoutNewRoute
  ProtectedLayoutPriceListsLayoutIndexRoute: typeof ProtectedLayoutPriceListsLayoutIndexRoute
}

const ProtectedLayoutPriceListsLayoutRouteChildren: ProtectedLayoutPriceListsLayoutRouteChildren =
  {
    ProtectedLayoutPriceListsLayoutIdRoute:
      ProtectedLayoutPriceListsLayoutIdRoute,
    ProtectedLayoutPriceListsLayoutNewRoute:
      ProtectedLayoutPriceListsLayoutNewRoute,
    ProtectedLayoutPriceListsLayoutIndexRoute:
      ProtectedLayoutPriceListsLayoutIndexRoute,
  }

const ProtectedLayoutPriceListsLayoutRouteWithChildren =
  ProtectedLayoutPriceListsLayoutRoute._addFileChildren(
    ProtectedLayoutPriceListsLayoutRouteChildren,
  )

interface ProtectedLayoutPriceListsRouteChildren {
  ProtectedLayoutPriceListsLayoutRoute: typeof ProtectedLayoutPriceListsLayoutRouteWithChildren
}

const ProtectedLayoutPriceListsRouteChildren: ProtectedLayoutPriceListsRouteChildren =
  {
    ProtectedLayoutPriceListsLayoutRoute:
      ProtectedLayoutPriceListsLayoutRouteWithChildren,
  }

const ProtectedLayoutPriceListsRouteWithChildren =
  ProtectedLayoutPriceListsRoute._addFileChildren(
    ProtectedLayoutPriceListsRouteChildren,
  )

interface ProtectedLayoutProductsLayoutRouteChildren {
  ProtectedLayoutProductsLayoutIdRoute: typeof ProtectedLayoutProductsLayoutIdRoute
  ProtectedLayoutProductsLayoutNewRoute: typeof ProtectedLayoutProductsLayoutNewRoute
  ProtectedLayoutProductsLayoutIndexRoute: typeof ProtectedLayoutProductsLayoutIndexRoute
}

const ProtectedLayoutProductsLayoutRouteChildren: ProtectedLayoutProductsLayoutRouteChildren =
  {
    ProtectedLayoutProductsLayoutIdRoute: ProtectedLayoutProductsLayoutIdRoute,
    ProtectedLayoutProductsLayoutNewRoute:
      ProtectedLayoutProductsLayoutNewRoute,
    ProtectedLayoutProductsLayoutIndexRoute:
      ProtectedLayoutProductsLayoutIndexRoute,
  }

const ProtectedLayoutProductsLayoutRouteWithChildren =
  ProtectedLayoutProductsLayoutRoute._addFileChildren(
    ProtectedLayoutProductsLayoutRouteChildren,
  )

interface ProtectedLayoutProductsRouteChildren {
  ProtectedLayoutProductsLayoutRoute: typeof ProtectedLayoutProductsLayoutRouteWithChildren
}

const ProtectedLayoutProductsRouteChildren: ProtectedLayoutProductsRouteChildren =
  {
    ProtectedLayoutProductsLayoutRoute:
      ProtectedLayoutProductsLayoutRouteWithChildren,
  }

const ProtectedLayoutProductsRouteWithChildren =
  ProtectedLayoutProductsRoute._addFileChildren(
    ProtectedLayoutProductsRouteChildren,
  )

interface ProtectedLayoutRegistryLayoutRouteChildren {
  ProtectedLayoutRegistryLayoutIndexRoute: typeof ProtectedLayoutRegistryLayoutIndexRoute
  ProtectedLayoutRegistryLayoutCounterpartsIdRoute: typeof ProtectedLayoutRegistryLayoutCounterpartsIdRoute
  ProtectedLayoutRegistryLayoutCounterpartsNewRoute: typeof ProtectedLayoutRegistryLayoutCounterpartsNewRoute
  ProtectedLayoutRegistryLayoutEmployeesIdRoute: typeof ProtectedLayoutRegistryLayoutEmployeesIdRoute
  ProtectedLayoutRegistryLayoutEmployeesNewRoute: typeof ProtectedLayoutRegistryLayoutEmployeesNewRoute
  ProtectedLayoutRegistryLayoutProductsIdRoute: typeof ProtectedLayoutRegistryLayoutProductsIdRoute
  ProtectedLayoutRegistryLayoutProductsNewRoute: typeof ProtectedLayoutRegistryLayoutProductsNewRoute
  ProtectedLayoutRegistryLayoutProductsNewServiceRoute: typeof ProtectedLayoutRegistryLayoutProductsNewServiceRoute
}

const ProtectedLayoutRegistryLayoutRouteChildren: ProtectedLayoutRegistryLayoutRouteChildren =
  {
    ProtectedLayoutRegistryLayoutIndexRoute:
      ProtectedLayoutRegistryLayoutIndexRoute,
    ProtectedLayoutRegistryLayoutCounterpartsIdRoute:
      ProtectedLayoutRegistryLayoutCounterpartsIdRoute,
    ProtectedLayoutRegistryLayoutCounterpartsNewRoute:
      ProtectedLayoutRegistryLayoutCounterpartsNewRoute,
    ProtectedLayoutRegistryLayoutEmployeesIdRoute:
      ProtectedLayoutRegistryLayoutEmployeesIdRoute,
    ProtectedLayoutRegistryLayoutEmployeesNewRoute:
      ProtectedLayoutRegistryLayoutEmployeesNewRoute,
    ProtectedLayoutRegistryLayoutProductsIdRoute:
      ProtectedLayoutRegistryLayoutProductsIdRoute,
    ProtectedLayoutRegistryLayoutProductsNewRoute:
      ProtectedLayoutRegistryLayoutProductsNewRoute,
    ProtectedLayoutRegistryLayoutProductsNewServiceRoute:
      ProtectedLayoutRegistryLayoutProductsNewServiceRoute,
  }

const ProtectedLayoutRegistryLayoutRouteWithChildren =
  ProtectedLayoutRegistryLayoutRoute._addFileChildren(
    ProtectedLayoutRegistryLayoutRouteChildren,
  )

interface ProtectedLayoutRegistryRouteChildren {
  ProtectedLayoutRegistryLayoutRoute: typeof ProtectedLayoutRegistryLayoutRouteWithChildren
}

const ProtectedLayoutRegistryRouteChildren: ProtectedLayoutRegistryRouteChildren =
  {
    ProtectedLayoutRegistryLayoutRoute:
      ProtectedLayoutRegistryLayoutRouteWithChildren,
  }

const ProtectedLayoutRegistryRouteWithChildren =
  ProtectedLayoutRegistryRoute._addFileChildren(
    ProtectedLayoutRegistryRouteChildren,
  )

interface ProtectedLayoutServiceContractsLayoutRouteChildren {
  ProtectedLayoutServiceContractsLayoutIdRoute: typeof ProtectedLayoutServiceContractsLayoutIdRoute
  ProtectedLayoutServiceContractsLayoutNewRoute: typeof ProtectedLayoutServiceContractsLayoutNewRoute
  ProtectedLayoutServiceContractsLayoutIndexRoute: typeof ProtectedLayoutServiceContractsLayoutIndexRoute
}

const ProtectedLayoutServiceContractsLayoutRouteChildren: ProtectedLayoutServiceContractsLayoutRouteChildren =
  {
    ProtectedLayoutServiceContractsLayoutIdRoute:
      ProtectedLayoutServiceContractsLayoutIdRoute,
    ProtectedLayoutServiceContractsLayoutNewRoute:
      ProtectedLayoutServiceContractsLayoutNewRoute,
    ProtectedLayoutServiceContractsLayoutIndexRoute:
      ProtectedLayoutServiceContractsLayoutIndexRoute,
  }

const ProtectedLayoutServiceContractsLayoutRouteWithChildren =
  ProtectedLayoutServiceContractsLayoutRoute._addFileChildren(
    ProtectedLayoutServiceContractsLayoutRouteChildren,
  )

interface ProtectedLayoutServiceContractsRouteChildren {
  ProtectedLayoutServiceContractsLayoutRoute: typeof ProtectedLayoutServiceContractsLayoutRouteWithChildren
}

const ProtectedLayoutServiceContractsRouteChildren: ProtectedLayoutServiceContractsRouteChildren =
  {
    ProtectedLayoutServiceContractsLayoutRoute:
      ProtectedLayoutServiceContractsLayoutRouteWithChildren,
  }

const ProtectedLayoutServiceContractsRouteWithChildren =
  ProtectedLayoutServiceContractsRoute._addFileChildren(
    ProtectedLayoutServiceContractsRouteChildren,
  )

interface ProtectedLayoutSettingsLayoutCategoriesIdRouteChildren {
  ProtectedLayoutSettingsLayoutCategoriesIdKeywordsRoute: typeof ProtectedLayoutSettingsLayoutCategoriesIdKeywordsRoute
}

const ProtectedLayoutSettingsLayoutCategoriesIdRouteChildren: ProtectedLayoutSettingsLayoutCategoriesIdRouteChildren =
  {
    ProtectedLayoutSettingsLayoutCategoriesIdKeywordsRoute:
      ProtectedLayoutSettingsLayoutCategoriesIdKeywordsRoute,
  }

const ProtectedLayoutSettingsLayoutCategoriesIdRouteWithChildren =
  ProtectedLayoutSettingsLayoutCategoriesIdRoute._addFileChildren(
    ProtectedLayoutSettingsLayoutCategoriesIdRouteChildren,
  )

interface ProtectedLayoutSettingsLayoutRouteChildren {
  ProtectedLayoutSettingsLayoutIndexRoute: typeof ProtectedLayoutSettingsLayoutIndexRoute
  ProtectedLayoutSettingsLayoutCategoriesIdRoute: typeof ProtectedLayoutSettingsLayoutCategoriesIdRouteWithChildren
  ProtectedLayoutSettingsLayoutCategoriesNewRoute: typeof ProtectedLayoutSettingsLayoutCategoriesNewRoute
  ProtectedLayoutSettingsLayoutUsersIdRoute: typeof ProtectedLayoutSettingsLayoutUsersIdRoute
  ProtectedLayoutSettingsLayoutUsersNewRoute: typeof ProtectedLayoutSettingsLayoutUsersNewRoute
}

const ProtectedLayoutSettingsLayoutRouteChildren: ProtectedLayoutSettingsLayoutRouteChildren =
  {
    ProtectedLayoutSettingsLayoutIndexRoute:
      ProtectedLayoutSettingsLayoutIndexRoute,
    ProtectedLayoutSettingsLayoutCategoriesIdRoute:
      ProtectedLayoutSettingsLayoutCategoriesIdRouteWithChildren,
    ProtectedLayoutSettingsLayoutCategoriesNewRoute:
      ProtectedLayoutSettingsLayoutCategoriesNewRoute,
    ProtectedLayoutSettingsLayoutUsersIdRoute:
      ProtectedLayoutSettingsLayoutUsersIdRoute,
    ProtectedLayoutSettingsLayoutUsersNewRoute:
      ProtectedLayoutSettingsLayoutUsersNewRoute,
  }

const ProtectedLayoutSettingsLayoutRouteWithChildren =
  ProtectedLayoutSettingsLayoutRoute._addFileChildren(
    ProtectedLayoutSettingsLayoutRouteChildren,
  )

interface ProtectedLayoutSettingsRouteChildren {
  ProtectedLayoutSettingsLayoutRoute: typeof ProtectedLayoutSettingsLayoutRouteWithChildren
}

const ProtectedLayoutSettingsRouteChildren: ProtectedLayoutSettingsRouteChildren =
  {
    ProtectedLayoutSettingsLayoutRoute:
      ProtectedLayoutSettingsLayoutRouteWithChildren,
  }

const ProtectedLayoutSettingsRouteWithChildren =
  ProtectedLayoutSettingsRoute._addFileChildren(
    ProtectedLayoutSettingsRouteChildren,
  )

interface ProtectedLayoutSupportLayoutRouteChildren {
  ProtectedLayoutSupportLayoutIdRoute: typeof ProtectedLayoutSupportLayoutIdRoute
  ProtectedLayoutSupportLayoutNewRoute: typeof ProtectedLayoutSupportLayoutNewRoute
  ProtectedLayoutSupportLayoutIndexRoute: typeof ProtectedLayoutSupportLayoutIndexRoute
}

const ProtectedLayoutSupportLayoutRouteChildren: ProtectedLayoutSupportLayoutRouteChildren =
  {
    ProtectedLayoutSupportLayoutIdRoute: ProtectedLayoutSupportLayoutIdRoute,
    ProtectedLayoutSupportLayoutNewRoute: ProtectedLayoutSupportLayoutNewRoute,
    ProtectedLayoutSupportLayoutIndexRoute:
      ProtectedLayoutSupportLayoutIndexRoute,
  }

const ProtectedLayoutSupportLayoutRouteWithChildren =
  ProtectedLayoutSupportLayoutRoute._addFileChildren(
    ProtectedLayoutSupportLayoutRouteChildren,
  )

interface ProtectedLayoutSupportRouteChildren {
  ProtectedLayoutSupportLayoutRoute: typeof ProtectedLayoutSupportLayoutRouteWithChildren
}

const ProtectedLayoutSupportRouteChildren: ProtectedLayoutSupportRouteChildren =
  {
    ProtectedLayoutSupportLayoutRoute:
      ProtectedLayoutSupportLayoutRouteWithChildren,
  }

const ProtectedLayoutSupportRouteWithChildren =
  ProtectedLayoutSupportRoute._addFileChildren(
    ProtectedLayoutSupportRouteChildren,
  )

interface ProtectedLayoutWarehouseLayoutRouteChildren {
  ProtectedLayoutWarehouseLayoutIndexRoute: typeof ProtectedLayoutWarehouseLayoutIndexRoute
}

const ProtectedLayoutWarehouseLayoutRouteChildren: ProtectedLayoutWarehouseLayoutRouteChildren =
  {
    ProtectedLayoutWarehouseLayoutIndexRoute:
      ProtectedLayoutWarehouseLayoutIndexRoute,
  }

const ProtectedLayoutWarehouseLayoutRouteWithChildren =
  ProtectedLayoutWarehouseLayoutRoute._addFileChildren(
    ProtectedLayoutWarehouseLayoutRouteChildren,
  )

interface ProtectedLayoutWarehouseRouteChildren {
  ProtectedLayoutWarehouseLayoutRoute: typeof ProtectedLayoutWarehouseLayoutRouteWithChildren
}

const ProtectedLayoutWarehouseRouteChildren: ProtectedLayoutWarehouseRouteChildren =
  {
    ProtectedLayoutWarehouseLayoutRoute:
      ProtectedLayoutWarehouseLayoutRouteWithChildren,
  }

const ProtectedLayoutWarehouseRouteWithChildren =
  ProtectedLayoutWarehouseRoute._addFileChildren(
    ProtectedLayoutWarehouseRouteChildren,
  )

interface ProtectedLayoutWorkReportsLayoutRouteChildren {
  ProtectedLayoutWorkReportsLayoutIdRoute: typeof ProtectedLayoutWorkReportsLayoutIdRoute
  ProtectedLayoutWorkReportsLayoutNewRoute: typeof ProtectedLayoutWorkReportsLayoutNewRoute
  ProtectedLayoutWorkReportsLayoutIndexRoute: typeof ProtectedLayoutWorkReportsLayoutIndexRoute
}

const ProtectedLayoutWorkReportsLayoutRouteChildren: ProtectedLayoutWorkReportsLayoutRouteChildren =
  {
    ProtectedLayoutWorkReportsLayoutIdRoute:
      ProtectedLayoutWorkReportsLayoutIdRoute,
    ProtectedLayoutWorkReportsLayoutNewRoute:
      ProtectedLayoutWorkReportsLayoutNewRoute,
    ProtectedLayoutWorkReportsLayoutIndexRoute:
      ProtectedLayoutWorkReportsLayoutIndexRoute,
  }

const ProtectedLayoutWorkReportsLayoutRouteWithChildren =
  ProtectedLayoutWorkReportsLayoutRoute._addFileChildren(
    ProtectedLayoutWorkReportsLayoutRouteChildren,
  )

interface ProtectedLayoutWorkReportsRouteChildren {
  ProtectedLayoutWorkReportsLayoutRoute: typeof ProtectedLayoutWorkReportsLayoutRouteWithChildren
}

const ProtectedLayoutWorkReportsRouteChildren: ProtectedLayoutWorkReportsRouteChildren =
  {
    ProtectedLayoutWorkReportsLayoutRoute:
      ProtectedLayoutWorkReportsLayoutRouteWithChildren,
  }

const ProtectedLayoutWorkReportsRouteWithChildren =
  ProtectedLayoutWorkReportsRoute._addFileChildren(
    ProtectedLayoutWorkReportsRouteChildren,
  )

interface ProtectedLayoutRouteRouteChildren {
  ProtectedLayoutAiChatRoute: typeof ProtectedLayoutAiChatRoute
  ProtectedLayoutDashboardRoute: typeof ProtectedLayoutDashboardRoute
  ProtectedLayoutHelpRoute: typeof ProtectedLayoutHelpRouteWithChildren
  ProtectedLayoutToInvoiceRoute: typeof ProtectedLayoutToInvoiceRoute
  ProtectedLayoutIndexRoute: typeof ProtectedLayoutIndexRoute
  ProtectedLayoutAccountsRoute: typeof ProtectedLayoutAccountsRouteWithChildren
  ProtectedLayoutAdministrationRoute: typeof ProtectedLayoutAdministrationRouteWithChildren
  ProtectedLayoutCommesseRoute: typeof ProtectedLayoutCommesseRouteWithChildren
  ProtectedLayoutDeliveryNotesRoute: typeof ProtectedLayoutDeliveryNotesRouteWithChildren
  ProtectedLayoutDistinteRibaRoute: typeof ProtectedLayoutDistinteRibaRouteWithChildren
  ProtectedLayoutDocumentPaymentSchedulesRoute: typeof ProtectedLayoutDocumentPaymentSchedulesRouteWithChildren
  ProtectedLayoutDocumentsRoute: typeof ProtectedLayoutDocumentsRouteWithChildren
  ProtectedLayoutForecastRoute: typeof ProtectedLayoutForecastRouteWithChildren
  ProtectedLayoutHotelRoute: typeof ProtectedLayoutHotelRouteWithChildren
  ProtectedLayoutInventoryRoute: typeof ProtectedLayoutInventoryRouteWithChildren
  ProtectedLayoutInvoicesRoute: typeof ProtectedLayoutInvoicesRouteWithChildren
  ProtectedLayoutMachineChecksRoute: typeof ProtectedLayoutMachineChecksRouteWithChildren
  ProtectedLayoutMachinesRoute: typeof ProtectedLayoutMachinesRouteWithChildren
  ProtectedLayoutOrdersRoute: typeof ProtectedLayoutOrdersRouteWithChildren
  ProtectedLayoutPaymentsRoute: typeof ProtectedLayoutPaymentsRouteWithChildren
  ProtectedLayoutPriceListsRoute: typeof ProtectedLayoutPriceListsRouteWithChildren
  ProtectedLayoutProductsRoute: typeof ProtectedLayoutProductsRouteWithChildren
  ProtectedLayoutRegistryRoute: typeof ProtectedLayoutRegistryRouteWithChildren
  ProtectedLayoutServiceContractsRoute: typeof ProtectedLayoutServiceContractsRouteWithChildren
  ProtectedLayoutSettingsRoute: typeof ProtectedLayoutSettingsRouteWithChildren
  ProtectedLayoutSupportRoute: typeof ProtectedLayoutSupportRouteWithChildren
  ProtectedLayoutWarehouseRoute: typeof ProtectedLayoutWarehouseRouteWithChildren
  ProtectedLayoutWorkReportsRoute: typeof ProtectedLayoutWorkReportsRouteWithChildren
}

const ProtectedLayoutRouteRouteChildren: ProtectedLayoutRouteRouteChildren = {
  ProtectedLayoutAiChatRoute: ProtectedLayoutAiChatRoute,
  ProtectedLayoutDashboardRoute: ProtectedLayoutDashboardRoute,
  ProtectedLayoutHelpRoute: ProtectedLayoutHelpRouteWithChildren,
  ProtectedLayoutToInvoiceRoute: ProtectedLayoutToInvoiceRoute,
  ProtectedLayoutIndexRoute: ProtectedLayoutIndexRoute,
  ProtectedLayoutAccountsRoute: ProtectedLayoutAccountsRouteWithChildren,
  ProtectedLayoutAdministrationRoute:
    ProtectedLayoutAdministrationRouteWithChildren,
  ProtectedLayoutCommesseRoute: ProtectedLayoutCommesseRouteWithChildren,
  ProtectedLayoutDeliveryNotesRoute:
    ProtectedLayoutDeliveryNotesRouteWithChildren,
  ProtectedLayoutDistinteRibaRoute:
    ProtectedLayoutDistinteRibaRouteWithChildren,
  ProtectedLayoutDocumentPaymentSchedulesRoute:
    ProtectedLayoutDocumentPaymentSchedulesRouteWithChildren,
  ProtectedLayoutDocumentsRoute: ProtectedLayoutDocumentsRouteWithChildren,
  ProtectedLayoutForecastRoute: ProtectedLayoutForecastRouteWithChildren,
  ProtectedLayoutHotelRoute: ProtectedLayoutHotelRouteWithChildren,
  ProtectedLayoutInventoryRoute: ProtectedLayoutInventoryRouteWithChildren,
  ProtectedLayoutInvoicesRoute: ProtectedLayoutInvoicesRouteWithChildren,
  ProtectedLayoutMachineChecksRoute:
    ProtectedLayoutMachineChecksRouteWithChildren,
  ProtectedLayoutMachinesRoute: ProtectedLayoutMachinesRouteWithChildren,
  ProtectedLayoutOrdersRoute: ProtectedLayoutOrdersRouteWithChildren,
  ProtectedLayoutPaymentsRoute: ProtectedLayoutPaymentsRouteWithChildren,
  ProtectedLayoutPriceListsRoute: ProtectedLayoutPriceListsRouteWithChildren,
  ProtectedLayoutProductsRoute: ProtectedLayoutProductsRouteWithChildren,
  ProtectedLayoutRegistryRoute: ProtectedLayoutRegistryRouteWithChildren,
  ProtectedLayoutServiceContractsRoute:
    ProtectedLayoutServiceContractsRouteWithChildren,
  ProtectedLayoutSettingsRoute: ProtectedLayoutSettingsRouteWithChildren,
  ProtectedLayoutSupportRoute: ProtectedLayoutSupportRouteWithChildren,
  ProtectedLayoutWarehouseRoute: ProtectedLayoutWarehouseRouteWithChildren,
  ProtectedLayoutWorkReportsRoute: ProtectedLayoutWorkReportsRouteWithChildren,
}

const ProtectedLayoutRouteRouteWithChildren =
  ProtectedLayoutRouteRoute._addFileChildren(ProtectedLayoutRouteRouteChildren)

interface ProtectedRouteRouteChildren {
  ProtectedLayoutRouteRoute: typeof ProtectedLayoutRouteRouteWithChildren
}

const ProtectedRouteRouteChildren: ProtectedRouteRouteChildren = {
  ProtectedLayoutRouteRoute: ProtectedLayoutRouteRouteWithChildren,
}

const ProtectedRouteRouteWithChildren = ProtectedRouteRoute._addFileChildren(
  ProtectedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRouteRoute: ProtectedRouteRouteWithChildren,
  AcceptInvitationRoute: AcceptInvitationRoute,
  EmailConfirmRoute: EmailConfirmRoute,
  ImpersonateRoute: ImpersonateRoute,
  PasswordResetRoute: PasswordResetRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  StudioRoute: StudioRoute,
  TermsRoute: TermsRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  ContractTokenRoute: ContractTokenRoute,
  DWrTokenRoute: DWrTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
